<template>
  <header id="page-topbar">
    <vue-internet-checker @status="status" />
    <div class="navbar-header">
      <div class="d-flex">
        <!-- LOGO -->
        <!-- TODO: hardcode whitelabel -->
        <div v-if="isDriver" class="navbar-brand-box" style="width: 250px !important">
          <router-link to="/" class="logo logo-dark">
            <span class="logo-lg" style="display: block">
              <img
                ref="imgPrimaryLogoMax"
                :src="getAsset('primaryLogo', 'login')"
                width="125px"
                alt
              />
            </span>
          </router-link>

          <router-link to="/" class="logo logo-light">
            <span class="logo-lg" style="display: block">
              <img
                ref="imgPrimaryLogoMax"
                :src="getAsset('primaryLogo', 'login')"
                width="125px"
                alt
              />
            </span>
          </router-link>
        </div>
        <div v-else-if="companyId !== 1449" class="navbar-brand-box">
          <router-link to="/" class="logo logo-dark">
            <span class="logo-sm">
              <img
                ref="imgPrimaryLogoMin"
                :src="getAsset('secondaryLogo', 'sidebarMinimize')"
                alt
              />
            </span>
            <span class="logo-lg">
              <img ref="imgPrimaryLogoMax" :src="getAsset('primaryLogo', 'login')" alt />
            </span>
          </router-link>

          <router-link to="/" class="logo logo-light">
            <span class="logo-sm">
              <img
                ref="imgPrimaryLogoMin"
                :src="getAsset('secondaryLogo', 'sidebarMinimize')"
                alt
              />
            </span>
            <span class="logo-lg">
              <img ref="imgPrimaryLogoMax" :src="getAsset('primaryLogo', 'login')" alt />
            </span>
          </router-link>
        </div>
        <div v-else class="navbar-brand-box">
          <router-link to="/" class="logo logo-dark">
            <span class="logo-sm">
              <img src="@/assets/images/whitelabel/logoariasmall.png" alt height="16" />
            </span>
            <span class="logo-lg">
              <img src="@/assets/images/whitelabel/logoariavertical.png" alt height="17" />
            </span>
          </router-link>

          <router-link to="/" class="logo logo-light">
            <span class="logo-sm">
              <img src="@/assets/images/whitelabel/logoariasmall.png" alt height="16" />
            </span>
            <span class="logo-lg">
              <img src="@/assets/images/whitelabel/logoariavertical.png" alt height="17" />
            </span>
          </router-link>
        </div>

        <button
          v-if="!isDriver"
          id="vertical-menu-btn"
          type="button"
          class="btn btn-sm px-3 font-size-16 header-item mc-burger-menu"
          @click="toggleMenu"
        >
          <i class="mc-fa icon-fill_menu"></i>
        </button>

        <div v-if="updateDetected" class="mc-onboarding-btn">
          <div class="d-flex align-items-center gap-2">
            <img
              alt="bell"
              src="@/assets/images/refresh-web.svg"
              style="cursor: pointer"
              @click="toggleNotification('update')"
            />
            <div
              class="mc-onboarding-btn-wrapper gap-2"
              :class="{ show: activeNotification === 'update' }"
            >
              <span class="font-size-12"> Pembaharuan tersedia, Refresh web untuk update </span>
              <span class="mc-onboarding-btn__cta" @click="refreshApp">
                Refresh ({{ formatCountdown(refreshCountdown) }})
                <i class="mc-fa icon-outline_refresh" />
              </span>
            </div>
          </div>
        </div>

        <div
          v-if="
            hasAccessAll(['alert_rule_template:read', 'alert_rule_template:create']) &&
            getOnboardingStatus() === false &&
            !getSetupOnboardingStatus()
          "
          class="mc-onboarding-btn"
        >
          <div class="d-flex align-items-center gap-2">
            <img
              alt="bell"
              src="@/assets/images/bell-icon.svg"
              style="cursor: pointer"
              @click="toggleNotification('onboarding')"
            />
            <div
              class="mc-onboarding-btn-wrapper gap-2"
              :class="{ show: activeNotification === 'onboarding' }"
            >
              <span class="font-size-12">
                {{ $t('notification.onboarding.getNotification') }}
              </span>
              <span class="mc-onboarding-btn__cta" @click="showOnboarding">
                {{ $t('global.view') }}
                <i class="mc-fa icon-fill_arrow-circle-right" />
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- App Search-->
      <!-- <form class="app-search d-none d-lg-block">
        <div class="position-relative">
          <input type="text" class="form-control" placeholder="Search..." />
          <span class="bx bx-search-alt"></span>
        </div>
      </form> -->

      <div class="d-flex align-items-center">
        <b-dropdown
          v-if="phaseOneShow"
          class="d-inline-block d-lg-none ms-2"
          variant="black"
          menu-class="dropdown-menu-lg p-0"
          toggle-class="header-item noti-icon"
          right
        >
          <template #button-content>
            <i class="mdi mdi-magnify"></i>
          </template>

          <form class="p-3">
            <div class="form-group m-0">
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Search ..."
                  aria-label="Recipient's username"
                />
                <div class="input-group-append">
                  <button class="btn btn-primary" type="submit">
                    <i class="mdi mdi-magnify"></i>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </b-dropdown>

        <!-- <b-dropdown
          variant="white"
          right
          toggle-class="header-item"
          class="mc-header-lang"
          v-if="$store.state.config.mode == 'development'"
        >
          <template v-slot:button-content>
            <img class :src="flag" alt="Header Language" height="16" />
            {{ text }}
          </template>
          <b-dropdown-item
            class="notify-item"
            v-for="(entry, i) in languages"
            :key="`Lang${i}`"
            :value="entry"
            @click="setLanguage(entry.language, entry.title, entry.flag)"
            :class="{ active: lan === entry.language }"
          >
            <img :src="`${entry.flag}`" alt="user-image" class="me-1" height="12" />
            <span class="align-middle">{{ entry.title }}</span>
          </b-dropdown-item>
        </b-dropdown> -->

        <!-- <div class="dropdown d-none d-lg-inline-block ms-1">
          <button
            type="button"
            class="btn header-item noti-icon"
            @click="initFullScreen"
          >
            <i class="bx bx-fullscreen"></i>
          </button>
        </div> -->

        <!-- TODO: hardcode whitelabel -->
        <b-button
          v-if="companyId !== 1449 && hasAccess('referal_program:read')"
          v-b-modal.modal-ref
          class="mc-btn--ref"
          variant="primary"
        >
          <i class="mc-fa icon-outline_people"></i>{{ 'Referral Program' }}
        </b-button>

        <div v-if="hasAccess(['e4a-alert-center-main:read'])" class="d-flex align-items-center">
          <div v-if="top3alert.length > 0" class="carousel-container">
            <transition-group
              name="slide"
              :enter-active-class="currentCarouselIndex == 0 ? 'slideDown' : 'slideUp'"
              :leave-active-class="currentCarouselIndex == 0 ? 'slideDown' : 'slideUp'"
            >
              <div
                v-if="top3alert[currentCarouselIndex]"
                :key="currentCarouselIndex"
                class="mc-notification-unread mb-2"
              >
                <img :src="top3alert[currentCarouselIndex].alert.iconUrl ?? ''" :alt="'icon'" />
                <span>
                  {{ top3alert[currentCarouselIndex]?.licensePlate }},
                  {{
                    language == 'en'
                      ? top3alert[currentCarouselIndex].alert.descriptionEng
                      : top3alert[currentCarouselIndex].alert.descriptionIdn
                  }}
                </span>
              </div>
            </transition-group>
          </div>

          <div class="mc-navbar-item_icon-btn">
            <div
              class="mc-notification-button"
              :class="{ active: alertCenterVisible }"
              @click="showAlertCenter"
            >
              <span
                :class="{
                  active: alertCenterVisible,
                  unread: hasUrgentUnresolved || top3alert.length > 0,
                  detached:
                    $store.state.sidebar.notifSideBarOpen ||
                    $store.state.notification.popupState.alertCenterPopup,
                }"
              >
                <i
                  :class="`mc-fa icon-outline_bell ${
                    hasUrgentUnresolved || top3alert.length > 0 ? 'mc-bell-ringing' : ''
                  }`"
                ></i>
                <span
                  v-if="hasUrgentUnresolved || top3alert.length > 0"
                  class="mc-badge-notification"
                />
              </span>
            </div>
          </div>
        </div>

        <div
          v-if="
            getFeatureFlagData('vsms2_system_notification').value &&
            hasAccess('system_notification:read')
          "
          class="mc-navbar-item_icon-btn"
          @click="showNotif()"
        >
          <i
            v-if="unreadAnnouncement === 0"
            class="mc-fa icon-outline_megaphone fs-4"
            style="cursor: pointer"
          />
          <i v-else class="mc-fa icon-fill_megaphone fs-4" style="cursor: pointer" />
          <span
            v-if="unreadAnnouncement > 0"
            class="badge rounded-pill bg-danger text-white position-absolute top-0 start-100 translate-middle"
          >
            {{ unreadAnnouncement }}
          </span>
        </div>
        <div
          v-if="companyId !== 1449 && hasAccess('customer-wish-feedback:create')"
          class="mc-navbar-item_icon-btn"
        >
          <McBadge
            v-if="isNewSubmodule('0d0-customer-wish-feedback')"
            class="me-1"
            variant="danger"
            size="small"
            type="notif"
          />
          <a
            :href="wishMeForm"
            class="d-flex align-items-center"
            target="_blank"
            @click="mixpanelWishForm"
          >
            <i
              v-b-tooltip.hover.bottom="{ customClass: 'mc-long-tooltip' }"
              class="icon-outline_message-square fs-4"
              :title="$t('navbar.text.feedback')"
            ></i>
          </a>
        </div>

        <div
          v-click-outside="closeAccountDropdown"
          :class="{
            'dropdown b-dropdown btn-group': dropDownAccount === false,
            'dropdown b-dropdown btn-group show': dropDownAccount === true,
          }"
          @click="toggleAccount"
        >
          <button type="button" class="btn dropdown-toggle btn-black header-item">
            <div>
              <span class="d-none d-xl-inline-block me-4">
                <div>{{ getUserName() }}</div>
              </span>
              <img
                v-if="getUserPhoto()"
                class="rounded-circle header-profile-user"
                :src="getUserPhoto()"
                alt="Header Avatar"
              />
              <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
            </div>
          </button>
          <ul
            role="menu"
            :class="{
              'dropdown-menu dropdown-menu-end dropdown-menu-right': dropDownAccount === false,
              'dropdown-menu dropdown-menu-end dropdown-menu-right show': dropDownAccount === true,
            }"
          >
            <a
              v-if="!isAllowed && hasAccess('back_to_vsms1:create')"
              v-b-modal.modal-vsms1
              class="dropdown-item"
              ><i class="mc-fa icon-outline_vsms font-size-16 align-middle me-1"></i>
              VSMS 1.0
            </a>
            <a class="dropdown-item" @click="$router.push({ name: 'Profile' })">
              <i class="icon-outline_person font-size-16 align-middle me-1"></i>
              {{ $t('navbar.dropdown.user.list.profile') }}
            </a>
            <a
              v-if="getFeatureFlagData('vsms2_bilingual').value && language === 'en'"
              class="dropdown-item"
              @click="setLanguage('id')"
            >
              <img
                src="@/assets/images/flags/ID - border.png"
                alt="id-flag"
                class="me-1"
                height="16"
              />
              <span class="align-middle"> {{ 'Bahasa Indonesia' }}</span>
            </a>
            <a
              v-if="getFeatureFlagData('vsms2_bilingual').value && language === 'id'"
              class="dropdown-item"
              @click="setLanguage('en')"
            >
              <img
                src="@/assets/images/flags/US - border.png"
                alt="eng-flag"
                class="me-1"
                height="16"
              />
              <span class="align-middle"> {{ 'English' }}</span>
            </a>
            <a class="dropdown-item" @click="logout">
              <i class="icon-outline_log-out font-size-16 align-middle me-1"></i>
              {{ $t('navbar.dropdown.user.list.logout') }}
            </a>
          </ul>
        </div>

        <!-- <div class="dropdown d-inline-block">
          <button
            type="button"
            class="btn header-item noti-icon right-bar-toggle toggle-right"
            @click="toggleRightSidebar"
          >
            <i class="bx bx-cog bx-spin toggle-right"></i>
          </button>
        </div> -->
      </div>
    </div>

    <b-modal
      v-if="hasAccess('referal_program:read')"
      id="modal-ref"
      ref="modal-ref"
      title=""
      size="lg"
      hide-footer
      hide-header
      modal-class="mc-modal-ref"
    >
      <div class="mc-modal-ref__Wrapper">
        <h4 class="text-primary mb-4">
          <strong>{{ $t('navbar.text.referralProgram') }}</strong>
        </h4>
        <div class="d-flex justify-content-between">
          <div>
            <p>
              {{ $t('navbar.text.referralInfo') }}
            </p>
            <p>
              {{ $t('navbar.text.referralDetail') }}
            </p>
            <small class="text-primary d-block">{{ $t('navbar.text.termsAndCondition') }}</small>
            <a
              href="https://forms.office.com/Pages/ResponsePage.aspx?id=jHVBIOfvdEW-exLvOtvgibJ0J2wLX_hAmTZ7OP9A5t1URVpCWVJPV1FHUUk1WFhWSTkwQkE0MFlSUC4u"
              target="_blank"
              class="btn btn-primary mt-4"
            >
              {{ $t('navbar.text.register') }}
            </a>
          </div>
          <div>
            <figure>
              <img src="@/assets/images/ref.png" alt />
            </figure>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      v-if="hasAccess('back_to_vsms1:create')"
      id="modal-vsms1"
      ref="modal-vsms1"
      title="Konfirmasi"
      size="md"
      hide-footer
      centered
      modal-class="mc-modal-vsms1"
    >
      <div class="mc-modal-vsms1__Wrapper">
        <p>
          Apa Anda yakin ingin kembali ke VSMS 1.0 ?
          <i class="text-danger">*</i>
        </p>
        <b-form-radio-group
          v-model="selectedVsms1"
          :options="confirmOptions"
          class="d-flex gap-xxl-5 mc-modal-navbar-header-dropdown-menu__vsms1__wrapper"
        />
        <b-form-group v-if="selectedVsms1">
          <p>
            Apa alasan Anda kembali menggunakan VSMS 1.0
            <i class="text-danger">*</i>
          </p>
          <b-form-radio-group
            v-model="reasonToVsms1"
            :options="options"
            class="my-2 mc-modal-navbar-header-dropdown-menu__vsms1__wrapper"
          />
          <b-form-input
            v-if="reasonToVsms1 == 4"
            v-model="otherReasonVsms1"
            type="text"
            placeholder="Masukkan Alasan Lain"
            class="mb-2"
          />
        </b-form-group>
        <div class="d-flex justify-content-end mt-2">
          <b-button
            id="cancel-to-vsms1-btn"
            class="mx-3"
            type="button"
            variant="outline-primary"
            @click="cancelToVsms1"
          >
            {{ $t('global.cancel') }}
          </b-button>
          <b-button id="go-to-vsms1-btn" type="button" variant="primary" @click="goToVsms1">
            {{ $t('global.save') }}
          </b-button>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="modal-notif"
      size="md"
      modal-class="modal-manage-notif"
      :title="$t('navbar.notif.announcement')"
      hide-footer
    >
      <b-skeleton-wrapper :loading="render">
        <template #loading>
          <b-row class="d-flex justify-content-end me-2 mx-2 mb-2">
            <b-skeleton width="40%" />
          </b-row>
          <div class="wrapper p-2">
            <div class="mc-modal__filter">
              <div v-for="index in 4" :key="index" class="mc-modal__filter-item">
                <b-alert show variant="primary">
                  <div class="d-flex">
                    <b-skeleton class="me-1 flex-grow-0 flex-shrink-0" width="5%" />
                    <b-skeleton class="flex-grow-0 flex-shrink-0" width="40%" />
                    <b-skeleton class="ms-auto flex-grow-0 flex-shrink-0" width="20%" />
                  </div>
                  <div class="px-4 me-2 my-2">
                    <b-skeleton width="100%" />
                    <b-skeleton width="100%" />
                    <b-skeleton width="55%" />
                  </div>
                  <b-skeleton-img card-img="top" aspect="3:1" />
                </b-alert>
              </div>
            </div>
          </div>
        </template>
        <b-row class="text-end" style="cursor: pointer" @click="updateRead(null)">
          <h5>{{ $t('navbar.notif.markAllAsRead') }}</h5>
        </b-row>
        <div class="wrapper p-2">
          <div ref="scrollContainer" class="mc-modal__filter" @scroll="systemNotifScroll">
            <div v-for="(item, index) in listNotif" :key="index" class="mc-modal__filter-item">
              <div style="cursor: pointer" @click="showNotifAction(item)">
                <b-alert v-if="!item.is_read" show variant="primary" class="custom-alert">
                  <b-row>
                    <b-col sm="1">
                      <i class="mc-fa icon-fill_info fs-4" />
                    </b-col>
                    <b-col sm="7">
                      <h5>
                        {{ item.system_notif_header }}
                      </h5>
                    </b-col>
                    <b-col sm="4" class="text-end">
                      {{ statusDate(item.created_on) }}
                    </b-col>
                  </b-row>
                  <b-row class="mb-2">
                    <b-col sm="11" offset-sm="1">
                      {{ item.system_notif_description }}
                    </b-col>
                  </b-row>
                  <b-row v-if="item.system_notif_thumbnail">
                    <div class="alert-thumbnail">
                      <img
                        :src="item.system_notif_thumbnail"
                        class="img-fluid rounded mx-auto d-block mt-1"
                        :alt="`Thumbnail${index + 1}`"
                      />
                    </div>
                  </b-row>
                </b-alert>
                <b-alert v-else show variant="light" class="custom-alert">
                  <b-row>
                    <b-col sm="1">
                      <i class="mc-fa icon-fill_info fs-4" />
                    </b-col>
                    <b-col sm="7">
                      <h5>
                        {{ item.system_notif_header }}
                      </h5>
                    </b-col>
                    <b-col sm="4" class="text-end">
                      {{ statusDate(item.created_on) }}
                    </b-col>
                  </b-row>
                  <b-row class="mb-2">
                    <b-col sm="11" offset-sm="1">
                      {{ item.system_notif_description }}
                    </b-col>
                  </b-row>
                  <b-row v-if="item.system_notif_thumbnail">
                    <div class="alert-thumbnail">
                      <img
                        v-if="item.system_notif_thumbnail"
                        :src="item.system_notif_thumbnail"
                        class="img-fluid rounded mx-auto d-block mt-1"
                        :alt="`Thumbnail${index + 1}`"
                      />
                    </div>
                  </b-row>
                </b-alert>
              </div>
            </div>
            <div v-if="isLoading" class="text-center">
              <b-spinner label="Loading..." />
            </div>
          </div>
        </div>
      </b-skeleton-wrapper>
    </b-modal>

    <NotifAction :notifAction="notifAction" :notifData="notifData" />

    <McDraggablePopup
      v-for="popup in popupLists"
      :id="popup.id"
      :key="popup.id"
      :data-popup-id="popup.id"
      :title="`${popup.alert.vehicle?.licensePlate} - ${
        hasRuleNameScope
          ? popup.alert.alertRule
            ? popup.alert.alertRule.label
            : $i18n.locale === 'id'
            ? popup.alert.alert.descriptionIdn
            : popup.alert.alert.descriptionEng
          : $i18n.locale === 'id'
          ? popup.alert.alert.descriptionIdn
          : popup.alert.alert.descriptionEng
      }`"
      :initialX="popup.x"
      :initialY="popup.y"
      :variant="getVariant(popup.alert, hasUrgentScope)"
      @positionChanged="
        (x, y) => $store.dispatch('notification/updatePosition', { id: popup.id, x, y })
      "
      @close="closePopup"
    >
      <template v-if="hasRuleNameScope" #badge>
        <div
          v-if="popup.alert.alertRuleIds && popup.alert.alertRuleIds.length > 1"
          class="notification-badge"
        >
          <div
            v-b-tooltip.hover.right="{
              title: getAlertTooltipText(popup.alert),
              customClass: 'mc-long-tooltip',
            }"
            class="tooltip-trigger"
          >
            <span
              class="badge badge-number"
              :class="`badge-${getVariant(popup.alert, hasUrgentScope)}`"
            >
              {{ popup.alert.alertRuleIds.length }}
            </span>
          </div>
        </div>
      </template>

      <div class="d-flex justify-content-between">
        <div class="mc-modal-ref__title-desc d-flex align-items-baseline">
          <McBadge
            v-if="hasFleetTaskInstantScope && isFO(popup.alert)"
            class="me-1"
            size="medium"
            :text="popup.alert.alertData?.split('|')[0]"
            type="button"
            variant="outlineSuccess"
          />
          <div class="mc-modal-multiimei__icon">
            <i
              v-b-tooltip.hover="
                `${$t('notification.text.sourceDevice')}: ${
                  popup.alert.sourceDeviceCategory === true ||
                  popup.alert.sourceDeviceCategory === 1
                    ? $t('trackVideo.camera')
                    : 'GPS'
                }`
              "
              :class="[
                'mc-fa',
                popup.alert.sourceDeviceCategory === true || popup.alert.sourceDeviceCategory === 1
                  ? 'icon-outline_video'
                  : 'icon-outline_device',
              ]"
            ></i>
          </div>
          <div>
            <span class="text-wrap font-size-13 fw-medium">
              {{
                $i18n.locale === 'id'
                  ? popup.alert.alert.descriptionIdn
                  : popup.alert.alert.descriptionEng
              }}
            </span>
            <p class="text-muted font-size-10">
              {{
                `${momentTime(popup.alert.createdOn)} ${getLabelTimezone()}, ${momentDateLongMonth(
                  popup.alert.createdOn
                )}`
              }}
            </p>
          </div>
        </div>

        <template v-if="!hasNewModalMediaAlert && hasMedia(popup.alert)">
          <McButton
            v-if="hasScopeMultiEvidence"
            variant="secondary"
            size="sm"
            icon="icon-outline_image"
            :text="$t('notification.action.seeMedia')"
            @click="openVideoModalEvidence(popup.alert)"
          />
          <div v-else class="mt-2">
            <McButton
              v-if="popup.alert.videoData"
              variant="secondary"
              size="sm"
              icon="icon-outline_image"
              :text="$t('notification.action.seeMedia')"
              @click="openVideo(popup.alert)"
            />
            <McButton
              v-else-if="popup.alert.canRequest"
              variant="secondary"
              size="sm"
              icon="icon-outline_download"
              text="Request Media"
              :disabled="popup.alert.pollingStatus == 'requesting'"
              @click="startReqMedia(popup.alert)"
            />
            <McButton
              v-else-if="popup.alert.canCheck"
              variant="secondary"
              size="sm"
              :icon="popup.alert.pollingStatus == 'checking' ? '' : 'icon-outline_refresh'"
              :text="$t('notification.action.checkMedia')"
              :disabled="popup.alert.pollingStatus == 'checking'"
              @click="pollForVideo(popup.alert)"
            >
              <template v-if="popup.alert.pollingStatus == 'checking'" #before-slot>
                <b-spinner small />
              </template>
            </McButton>
            <span
              v-else-if="
                popup.alert.pollingStatus == 'loading' &&
                (!popup.alert.canCheck || !popup.alert.canRequest)
              "
              class="mc-upload-state"
            >
              <i class="mc-fa icon-outline_more-horizontal"></i>
              <span class="d-flex align-items-center">
                {{ $t('global.action.uploadProcess') }}
              </span>
            </span>
            <McAlert
              v-else-if="popup.alert.pollingStatus == 'failed'"
              class="mc-alert-button"
              withIcon
              variant="error"
              :text="$t('global.noMedia')"
            />
          </div>
        </template>
      </div>
      <div class="d-flex align-items-center gap-2 py-2">
        <i class="icon-fill_driver-2 text-muted" style="font-size: 24px; line-height: 1"></i>
        <span v-b-tooltip.hover :title="popup.alert?.driver?.fullname ?? '-'" class="text-muted">{{
          hasVgroupItems(popup.id)
            ? truncateCharacter(popup.alert?.driver?.fullname ?? '-', 5)
            : popup.alert?.driver?.fullname ?? '-'
        }}</span>
        <span v-if="hasVgroupItems(popup.id)" class="border-end border-2" style="height: 16px" />
        <!-- Vgroup Section -->
        <McChipList
          v-if="hasVgroupItems(popup.id)"
          class="alert-center__popup-vgroup"
          :data-me="`alert-center-popup-vgroup-${popup.alert.rawAlertId || popup.id}`"
          :items="popupVgroupItemsMap[popup.id] || []"
          itemTextField="name"
          variant="outline-secondary"
          :hideToggle="true"
          :maxVisible="3"
          :truncateTextLength="
            (popupVgroupItemsMap[popup.id]?.length ?? 0) > 3 &&
            (popup.alert?.driver?.fullname?.length ?? 0)
              ? 5
              : 7
          "
        />
      </div>

      <!-- End Vgroup Section -->
      <div v-if="hasNewModalMediaAlert" class="alert-media-preview d-flex gap-1">
        <div class="alert-media-preview__map">
          <b-card
            class="rounded border-0 shadow-sm"
            body-class="p-0"
            footer-class="px-2 bg-white border-top d-flex align-items-center"
          >
            <template #footer>
              <i class="mc-fa icon-outline_pin me-2"></i>

              <a
                class="text-primary font-size-10 text-truncate"
                :data-me="`alert-center-popup-link-open-map-${popup.alert.rawAlertId || popup.id}`"
                style="cursor: pointer"
                @click="openMap(popup.alert)"
              >
                {{ popup.alert.address }}
              </a>
            </template>
            <div v-if="gmapType == 'Static'" class="p-0 mc-map-alert-wrapper">
              <img
                :src="popup.alert.mapUrl"
                class="mc-map-alert w-100"
                style="object-fit: cover; border-radius: 4px 4px 0 0"
              />
            </div>
            <div v-if="gmapType == 'Embed'" class="p-0 iframe-gmap-alert-wrapper">
              <iframe
                width="100%"
                height="200"
                frameborder="0"
                style="border: 0; display: block; border-radius: 4px 4px 0 0"
                referrerpolicy="no-referrer-when-downgrade"
                :src="`https://www.google.com/maps/embed/v1/place?key=${gmapApiKey}&q=${popup.alert.latitude},${popup.alert.longitude}`"
                allowfullscreen
              >
              </iframe>
            </div>
          </b-card>
        </div>
        <div v-if="canShowAlertMediaPanel(popup.alert)" class="alert-media-preview__media d-flex">
          <MediaPanel
            :data-me="`alert-center-popup-media-panel-${popup.alert.rawAlertId || popup.id}`"
            :alert="popup.alert"
            @retry-checking="openNewModal(popup.alert, 'check-media')"
            @play-media="openNewModal(popup.alert, 'play-media')"
            @request-media="openNewModal(popup.alert, 'request-media')"
            @refresh-media="refreshMediaUrl(popup.alert)"
          />
        </div>
      </div>
      <template v-else>
        <div class="row">
          <div v-if="gmapType == 'Static'" class="col-md-12 mc-map-alert-wrapper">
            <img :key="popup.alert.mapUrl" :src="popup.alert.mapUrl" class="mc-map-alert" />
          </div>
          <div v-if="gmapType == 'Embed'" class="col-md-12 iframe-gmap-alert-wrapper">
            <iframe
              width="100%"
              height="200"
              frameborder="0"
              style="border: 0"
              referrerpolicy="no-referrer-when-downgrade"
              :src="`https://www.google.com/maps/embed/v1/place?key=${gmapApiKey}&q=${popup.alert.latitude}, ${popup.alert.longitude}`"
              allowfullscreen
            >
            </iframe>
          </div>
        </div>
        <a class="text-primary font-size-10" @click="openMap(popup.alert)">
          {{ popup.alert.address }}
        </a>
      </template>

      <AlertData :alert="popup.alert" class="mc-popup-alert-data" />

      <div v-if="popup.alert.alertCode == 151" class="row">
        <div class="col-md-12">
          <span class="text-muted font-size-12">{{ $t('notification.field.deliveryNumber') }}</span>
          <p class="font-size-13 fw-medium">
            {{ `${popup.alert.alertData.split('|')[3]?.trim().replace(/\.0$/, '')}` || '-' }}
          </p>
        </div>
        <div class="col-md-6">
          <span class="text-muted font-size-12">{{ $t('notification.field.actualTemp') }}</span>
          <p class="font-size-13 fw-medium">
            {{ `${popup.alert.alertData.split('|')[4]?.trim().replace(/\.0$/, '')} ℃` || '-' }}
          </p>
        </div>
        <div class="col-md-6">
          <span class="text-muted font-size-12">
            <span
              v-if="
                Number(popup.alert.alertData.split('|')[4]) >
                Number(popup.alert.alertData.split('|')[5])
              "
            >
              {{ $t('notification.field.maxTempLimit') }}</span
            >
            <span v-else>{{ $t('notification.field.minTempLimit') }}</span>
          </span>
          <p class="font-size-13 fw-medium">
            {{
              popup.alert.alertData.split('|')[3]?.trim() === 'Multi DO'
                ? `${popup.alert.alertData.split('|')[3]?.trim()}`
                : `${popup.alert.alertData.split('|')[5]?.trim().replace(/\.0$/, '')} ℃` || '-'
            }}
          </p>
        </div>
      </div>

      <div v-if="hasFleetTaskInstantScope && isFO(popup.alert)">
        <div class="row">
          <div v-for="data in foData(popup.alert)" :key="data.title" class="col-md-6">
            <span class="text-muted font-size-12">{{ $t(data.title) }}</span>
            <p class="font-size-13 fw-medium">
              {{ data.value }}
            </p>
          </div>
        </div>
      </div>

      <div v-if="hasNewModalMediaAlert" class="pt-1 pb-3 mc-modal-fleet__action-items-list">
        <div class="d-flex justify-content-center align-items-center gap-2 text-primary">
          <i
            v-for="(icon, index) in getActionIcons(popup.alert)"
            :key="icon.icon"
            v-b-tooltip.hover="$t(icon.label)"
            :class="[
              icon.icon,
              icon.isDangerVariant ? 'text-danger border-danger' : 'border-primary',
              icon.disabled ? 'text-muted border-secondary' : 'border-primary',
            ]"
            :disabled="icon.disabled"
            :data-me="`alert-center-popup-action-${index}-${popup.alert.rawAlertId || popup.id}`"
            class="fs-5 border rounded-circle d-inline-flex align-items-center justify-content-center"
            :style="{
              width: '28px',
              height: '28px',
              cursor: icon.disabled ? 'not-allowed' : 'pointer',
            }"
            @click.prevent="!icon.disabled && icon.action()"
          />
        </div>
      </div>

      <FalseAlertActionCard
        :data-me="`alert-center-popup-false-alert-card-${popup.alert.rawAlertId || popup.id}`"
        :popup="popup"
        :action-handlers="getFalseAlertActionHandlers(popup)"
        @form-change="handleFormChange(popup.id, $event)"
      />

      <AlertCommentCard
        v-if="!popup.formOpen"
        :data-me="`alert-center-popup-comment-card-${popup.alert.rawAlertId || popup.id}`"
        :note="popup.note"
        :user-logs="popup.alert.userLogs"
        :save-action="(note) => saveNote({ ...popup, note }, false)"
        @input="handleNoteInput(popup.id, $event)"
      />

      <template v-if="!hasNewModalMediaAlert" #footer>
        <div
          :class="{
            'd-flex alert-center__footer': true,
            'justify-content-between': !popup.alert?.isCDMAlert,
            'justify-content-end': popup.alert?.isCDMAlert,
          }"
        >
          <template v-if="!popup.alert?.isCDMAlert">
            <McButton
              v-if="hasFleetTaskInstantScope && isFO(popup.alert)"
              variant="secondary"
              :text="$t('notification.text.viewDetailFO')"
              size="sm"
              @click="openQADetail(popup.alert)"
            />
            <McButton
              v-else
              variant="secondary"
              :text="$t('tower.trackVehicles')"
              size="sm"
              @click="openLiveview(popup.alert)"
            />
          </template>
          <b-dropdown size="sm" variant="outline-primary">
            <template #button-content>
              {{ $t('global.action.moreAction') }}
              <i class="mc-fa icon-outline_arrow-ios-down" />
            </template>
            <b-dropdown-item
              :href="getNotificationUrl(popup.alert)"
              @click="openDetailAlert(popup.alert)"
            >
              <i class="mc-fa icon-outline_file-text" />
              {{ $t('notification.title.notificationDetail') }}
            </b-dropdown-item>
            <template v-if="vehicleIdsCallActive.includes(popup.alert?.callState?.vehicleIdVoip)">
              <b-dropdown-item class="alert-center__end-call" @click="clickEndCall(popup.alert)">
                <i class="mc-fa icon-outline_phone-off" />
                {{ $t('trackVideo.endCall') }}
              </b-dropdown-item>
            </template>
            <template v-else>
              <b-dropdown-item
                v-if="
                  hasAccessAll([
                    'b3f-two-way-communication:read',
                    'b3f-two-way-communication-all-module:read',
                  ]) &&
                  (popup.alert?.callState?.deviceType === 'bsj' ||
                    popup.alert?.callState?.deviceType === 'vss-howen')
                "
                :disabled="
                  (vehicleIdsCallActive.length >= $store.state.voip.maxCall &&
                    !vehicleIdsCallActive.includes(popup.alert?.callState?.vehicleIdVoip)) ||
                  $store.state.voip.isBroadcastActive
                "
                @click="clickCall(popup.alert)"
              >
                <i class="mc-fa icon-outline_phone" />
                {{ $t('notification.action.callDriver') }}
              </b-dropdown-item>
            </template>
          </b-dropdown>
        </div>
      </template>
    </McDraggablePopup>

    <AlertCenter
      ref="alertCenter"
      :alertRulesObj="alertRulesObj"
      :notification="alertWS"
      :isVisible.sync="alertCenterVisible"
      @open-popup="handleNavbarPopup"
      @close-popup="closePopup"
    />
    <template v-if="hasScopeMultiEvidence">
      <ModalVideoV2
        v-if="selectedAlert"
        :licensePlate="selectedAlert?.vehicle.licensePlate"
        :category="selectedAlert?.vehicle?.vehicleType?.category ?? '-'"
        :driver="selectedAlert.driver?.fullname ?? '-'"
        :phoneNo="selectedAlert.vehicle.device?.phoneNo ?? '-'"
        :imei="selectedAlert?.vehicle.imei"
        :descriptionEng="selectedAlert.alert.descriptionEng"
        :descriptionIdn="selectedAlert.alert.descriptionIdn"
        :statusText="statusTextSelected"
        :dataDvh="dataDvh"
        :deviceCode="deviceCodeSelected"
        :vehicleIdCam="vehicleIdCamSelected"
        :imeiCam="imeiCamSelected"
        :rawAlertCreatedOn="selectedAlert.createdOn"
        :rawAlertId="selectedAlert.rawAlertId"
        :createdOn="selectedAlert.createdOn"
        :alertCode="selectedAlert.alert?.alertCode ?? selectedAlert.alertCode"
        @updateDataDvh="updateDataDvh"
        @close="selectedAlert = null"
      />
    </template>
    <template v-else>
      <ModalVideo
        v-if="selectedAlert"
        :alert="selectedAlert"
        :url="videoUrl"
        @close="selectedAlert = null"
      />
    </template>
    <b-modal
      id="modal-alert-action"
      :title="getModalTitle"
      ok-variant="primary"
      cancel-variant="outline-primary"
      :ok-title="$t('global.action.save')"
      :cancel-title="$t('global.action.cancel')"
      centered
      @ok="handleModalAction"
    >
      <p>{{ getModalText }}</p>
    </b-modal>
    <ModalOnboarding
      v-if="
        onboardingVisible &&
        hasAccessAll(['alert_rule_template:read', 'alert_rule_template:create'])
      "
      :show.sync="onboardingVisible"
    />
    <ModalReminder />
  </header>
</template>

<script>
import axios from 'axios'
import { mapState, mapGetters, mapActions } from 'vuex'
import { authComputed } from '@/state/helpers'
import i18n from '@/i18n'
import { Helper } from '@/mixin/helper'
import update from '@/mixin/update'
import { getApp, deleteApp } from 'firebase/app'
import { deleteToken, getMessaging } from 'firebase/messaging'
import Swal from 'sweetalert2'
import McBadge from '@/components/McBadge'
import McButton from '@/components/McButton'
import McChipList from '@/components/McChipList'
import vueInternetChecker from 'vue-internet-checker'
import { GET_PAYLOAD, VSMS_V1 } from '@/services/api/auth'
import { MixPanel } from '@/mixin/mixpanel'
import * as systemNotificationUser from '@/services/rest-api-vsms/lib/system-notification/system-notification-user'
import * as systemNotification from '@/services/rest-api-vsms/lib/system-notification/system-notification'
import moment from 'moment'
import NotifAction from './Modal/NotifAction'
import { UNREGISTER_FCM_TOKEN } from '@/services/api/fcm'
import McDraggablePopup from '@/components/McDraggablePopup'
import AlertData from '@/components/ModalAlertMedia/AlertData.vue'
import AlertCenter from './AlertCenter'
import { unregisterFCMServiceWorkers } from '@/helpers/unregister-service-workers'
import { FIND_DOWNLOAD_VIDEO_HISTORIES_FOR_NOTIFICATION_MEDIA } from '@/services/api/videoHistory/videos'
import ModalVideo from './Modal/ModalVideo'
import { GET_VEHICLE_STATUSES_LAST_RECEIVE, GET_RAW_ALERT } from '@/services/api/fleet'
import { GET_VEHICLE_STATUSES_TRACKVISION } from '@/services/api/fleet'
import { debounce } from '@/mixin/helper'
import { EventBus } from '@/router/views/fleet-task/lib/event-bus'
import ModalOnboarding from './Modal/ModalOnboarding'
import ModalReminder from './Modal/ModalReminder'
import * as FleetTaskInstant from '@/services/rest-api/lib/fleet-task-instant/fleet-task-instant'
import msgpack from 'msgpack-lite'
import { GET_VEHICLE_STATUS_TEXT, GET_VEHICLE_TV_DATA } from '@/services/api/trackvideo/video'
import { SET_UPLOAD_MEDIA, UPDATE_FILELIST } from '@/services/api/onlineCommand'

import ModalVideoV2 from './Modal/ModalVideoV2.vue'
import MediaPanel from './AlertCenter/Media/MediaPanel.vue'
import AlertCommentCard from './AlertCenter/CommentCard.vue'
import FalseAlertActionCard from './AlertCenter/FalseAlertActionCard.vue'
import { getAlertActionIcons } from './AlertCenter/lib/icon-actions'
import { getDeviceCode } from './AlertCenter/lib/device'
import {
  canShowAlertMediaPanel,
  isDmsAdas,
  isBsdAlert,
  hasCaptureEventMedia,
  getAlertMediaRequestType,
} from './AlertCenter/lib/alert-media'
import {
  createAlertActionForm,
  createAlertActionContext,
  createFalseAlertActionHandlers,
  getAlertActionModalText,
  getAlertActionModalTitle,
  normalizeAlertNote,
  saveAlertNoteAction,
  saveAlertResolveAction,
  saveFalseAlertAction,
  waitModalHidden,
} from './AlertCenter/lib/alert-actions'
import { Notification } from '@/mixin/notification'

const soundNotification = require('@/assets/sounds/notification_sound.wav')
const urgentSoundNotification = require('@/assets/sounds/urgent_notification.mp3')

// constants polling
const MEDIA_EXPIRY_DAYS = 3
const MEDIA_POLL_THRESHOLD_MINUTES = 10
const MEDIA_POLL_RETRY_INTERVAL_MS = 30 * 1000
const MEDIA_POLL_MAX_RETRY = 2

/**
 * Nav-bar Component
 */
export default {
  components: {
    vueInternetChecker,
    McBadge,
    McButton,
    NotifAction,
    McDraggablePopup,
    AlertData,
    AlertCenter,
    ModalVideo,
    ModalVideoV2,
    ModalOnboarding,
    ModalReminder,
    MediaPanel,
    AlertCommentCard,
    FalseAlertActionCard,
    McChipList,
  },
  mixins: [Helper, update, MixPanel, Notification],
  apollo: {
    getPayload: {
      query: GET_PAYLOAD,
      variables() {
        let isSharedVehicle = false
        if (this.$store.state.identity.whoami.scopes.includes('shared_vehicle:read')) {
          isSharedVehicle = true
        }
        let filterByType = ['SystemNotif']

        if (
          this.$store.state.identity.whoami.scopes.includes('control_tower:read') ||
          this.$store.state.identity.whoami.scopes.includes('h1b-control-tower-v2:read') ||
          this.$store.state.identity.whoami.scopes.includes(
            'b3j-trackvision-live-streaming:read'
          ) ||
          this.$store.state.identity.whoami.scopes.includes('b3h-new-trackvision-menu:read')
        ) {
          filterByType.push('GPS')
        }

        if (this.$store.state.identity.whoami.scopes.includes('b3h-new-trackvision-menu:read')) {
          filterByType.push('DownloadVideoHistory')
        }

        if (this.$store.state.identity.whoami.scopes.includes('e4a-alert-center-main:read')) {
          filterByType.push('AlertCenter')
        }
        return {
          filter: {
            isSharedVehicle,
            filterByType,
            alertRuleType: filterByType.includes('AlertCenter') ? 'Object' : null,
            includeDvhAutoUpload: this.hasAccess('b3t-trackvision-new-modal-media-alert:read')
              ? true
              : undefined,
          },
        }
      },
      result({ data, loading }) {
        if (loading) return

        if (data.getPayload.isSuccessful) {
          this.internalPayload = data.getPayload.payload.payload
          localStorage.setItem('payload', this.internalPayload)
          this.alertRulesObj = data.getPayload.payload.subscribedAlertRules

          let alertRuleIds = {
            urgentAlertRules: Object.keys(this.alertRulesObj.urgentAlertRules).map((id) =>
              Number(id)
            ),
            importantAlertRules: Object.keys(this.alertRulesObj.importantAlertRules).map((id) =>
              Number(id)
            ),
            autoPopupAlertRules: Object.keys(this.alertRulesObj.autoPopupAlertRules).map((id) =>
              Number(id)
            ),
          }

          this.$store.commit('notification/SET_ALERT_RULES_OBJ', this.alertRulesObj)
          this.$store.commit('notification/SET_ALERT_RULE_IDS', alertRuleIds)

          localStorage.setItem('alertRules', JSON.stringify(this.alertRulesObj))
          localStorage.setItem('alertRuleIds', JSON.stringify(alertRuleIds))
        }
      },
    },
  },
  data() {
    return {
      activeNotification: 'update',
      selectedPopup: null,
      language: i18n.locale,
      text: null,
      myVar: 1,
      dropDownAccount: false,
      phaseOneShow: false,
      onLine: navigator.onLine,
      selectedVsms1: false,
      reasonToVsms1: null,
      otherReasonVsms1: '',
      companyList: process.env.VUE_APP_LIST_COMPANY,
      companyId: this.getCompanyId(),
      isAllowed: false,
      modalType: '',
      options: [
        { value: 0, text: 'Tidak paham cara menggunakan All New VSMS' },
        {
          value: 1,
          text: 'Terdapat data yang belum terbarui pada All New VSMS',
        },
        { value: 2, text: 'Masih terbiasa menggunakan VSMS 1.0' },
        {
          value: 3,
          text: 'Terdapat fitur yang belum lengkap dalam All New VSMS',
        },
        { value: 4, text: 'Alasan lain' },
      ],
      confirmOptions: [
        { value: false, text: 'Tidak' },
        { value: true, text: 'Ya' },
      ],
      userPhoto: null,
      wishMeForm: process.env.VUE_APP_WISHME_FEEDBACK_FORM,
      showModalNotif: false,
      notifAction: '',
      notifData: {},
      listNotif: [],
      limit: 10,
      totalCount: 0,
      isLoading: false,
      render: false,
      currentCarouselIndex: 0,
      lastPong: moment(),
      listNotifAction: ['pop_up_image', 'carousel_image', 'pop_up_video'],
      internalPayload: null,
      alertSubscriptionsRefreshPromise: null,
      alertSubscriptionsRefreshQueued: false,
      forceDisconnect: false,
      pongInterval: null,
      alertCenterVisible: false,
      alertRulesObj: {},
      alertWS: {},
      map: null,
      mapOptions: {
        zoomControl: false, // Disable zoom control
        mapTypeControl: false, // Disable map type control
        streetViewControl: false, // Disable street view control
        fullscreenControl: false, // Disable fullscreen control
        clickableIcons: false, // This disables Google's POI clicks
        disableDefaultUI: true,
      },
      top3alert: [],
      selectedAlert: null,
      videoUrl: '',
      vehicleStatusesLastReceive: [],
      vehicleStatus: {},
      gmapApiKey: process.env.VUE_APP_GOOGLE_MAP_API_KEY,
      onboardingVisible: false,
      hasUrgentUnresolved: false, // <-- untuk animasi bell dari AlertCenter

      dataDvh: [], // for multievidence
      statusTextSelected: null,
      deviceCodeSelected: null,
      vehicleIdCamSelected: null,
      imeiCamSelected: null,
      rawAlertId: null,
    }
  },
  computed: {
    ...authComputed,
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
      hasAccessAll: 'identity/hasAccessAll',
      getAsset: 'asset/getAsset',
      isNewSubmodule: 'identity/isNewSubmodule',
      getFeatureFlagData: 'identity/getFeatureFlagData',
      getFeatureFlagValue: 'identity/getFeatureFlagValue',
    }),
    ...mapState('announcement', ['unreadAnnouncement']),
    ...mapState('notification', ['activePopups']),
    gmapType() {
      return this.$store.state.map.gMapGenerate
    },
    isDriver() {
      return (
        this.hasAccessAll(['tms_driver:read', 'tms_driver:update']) &
        !this.hasAccess(['vgroups:read'])
      )
    },
    ...mapGetters('video', ['vehicleStatusByVehicleId']),
    ...mapGetters('voip', ['vehicleIdsCallActive']),
    popupLists() {
      return this.activePopups
    },
    hasUrgentScope() {
      return this.hasAccess('e4e-alert-center-urgent:read')
    },
    falseAlertReasons() {
      return [
        {
          key: 'others',
          label: this.$t('notification.text.otherReasons'),
          value: 'Alasan Lainnya',
        },
      ]
    },
    hasScopeMultiEvidence() {
      return this.hasAccess('b3s-trackvision-multi-evidence:read')
    },
    hasNewModalMediaAlert() {
      return this.hasAccessAll([
        'b3t-trackvision-new-modal-media-alert:read',
        'e4a-alert-center-main:read',
      ])
    },
    getModalTitle() {
      return getAlertActionModalTitle(this.modalType, this.$t.bind(this))
    },
    getModalText() {
      return getAlertActionModalText(this.modalType, this.$t.bind(this))
    },
    hasFleetTaskInstantScope() {
      return this.hasAccessAll([
        'fleet-task-instant:read',
        'fleet-task-instant:create',
        'fleet-task-instant:update',
        'fleet-task-instant:delete',
      ])
    },
    isFO() {
      const FOalertCode = [143, 142, 141, 140, 139, 138, 137]
      return (item) => {
        return FOalertCode.includes(item.alertCode)
      }
    },
    hasRuleNameScope() {
      return this.hasAccess('e4J-alert-rule-name-as-title:read')
    },
    alertRuleIds() {
      return this.$store.state.notification.alertRuleIds
    },
    allRulesObj() {
      return {
        ...this.alertRulesObj.urgentAlertRules,
        ...this.alertRulesObj.importantAlertRules,
        ...this.alertRulesObj.autoPopupAlertRules,
      }
    },
    popupVgroupItemsMap() {
      const map = {}
      for (const popup of this.popupLists) {
        map[popup.id] = this.getSortedVgroupItems(popup.alert?.vehicle?.vehicle2Vgroup)
      }
      return map
    },
  },
  watch: {
    '$store.state.identity.whoami': {
      handler(val) {
        if (val) {
          this.userPhoto = this.getUserPhoto()
        }
      },
      deep: true,
    },
    showModalNotif(newValue) {
      if (!newValue) return
    },
    '$i18n.locale': {
      handler(val) {
        this.popupLists.map((popup) => {
          if (popup.note) {
            this.handleNoteInput(popup.id, popup.note)
          }
        })
      },
    },
    $route() {
      if (!this.isCheckingSW && !this.updateDetected) {
        this.isCheckingSW = true
        this.checkServiceWorkerUpdate().finally(() => {
          this.isCheckingSW = false
        })
      }
    },
  },

  async mounted() {
    // Register message handler for global websocket
    this.wsMessageHandler = this.handleWebSocketMessage.bind(this)
    await this.$store.dispatch('ws/registerMessageHandler', this.wsMessageHandler)

    // Only initialize WebSocket if App.vue hasn't already done it
    // App.vue handles global initialization, NavBar just ensures it's connected
    if (
      this.$route.name !== 'Control Tower V2' &&
      this.$route.name !== 'Control Tower' &&
      this.$route.name !== 'Live Streaming Trackvision' &&
      this.$route.name !== 'Video History Trackvision'
    ) {
      // Check if websocket needs initialization
      // Only initialize if NOT connected AND NOT connecting
      if (!this.$store.state.ws.socket.isConnected && !this.$store.state.ws.socket.isConnecting) {
        await this.initWebSocket()
      } else if (this.$store.state.ws.socket.isConnecting) {
        // Wait for connection to complete
        await new Promise((resolve) => {
          const checkConnection = setInterval(() => {
            if (this.$store.state.ws.socket.isConnected) {
              clearInterval(checkConnection)
              resolve()
            }
          }, 100)
          setTimeout(() => {
            clearInterval(checkConnection)
            resolve()
          }, 10000)
        })
      }
    }

    this.generateGMapType()
    const savedPopups = localStorage.getItem('activePopups')
    if (savedPopups) {
      const parsedPopups = JSON.parse(savedPopups)
      parsedPopups.forEach((popup) => {
        if (popup.isResolving === undefined) {
          popup.isResolving = false
        }
      })
      this.$store.commit('notification/LOAD_POPUPS', parsedPopups)
      this.popupLists.map((popup) => {
        if (this.hasAlertMedia(popup.alert)) {
          if (popup.alert.pollingStatus == 'loading') this.getDetailedVideo(popup.alert)
          else if (popup.alert.pollingStatus == 'checking') this.pollForVideo(popup.alert)
          else if (popup.alert.pollingStatus == 'requesting') this.startReqMedia(popup.alert)
          else if (!popup.alert.pollingStatus) {
            popup.alert['pollingStatus'] = 'loading'
            this.getDetailedVideo(popup.alert)
          }
        }
        const lastOpenedAt = popup.lastOpenedAt

        const isOlderThan10Min =
          lastOpenedAt && Date.now() - new Date(lastOpenedAt).getTime() > 10 * 60 * 1000
        if (isOlderThan10Min) {
          this.$set(popup, 'lastOpenedAt', new Date().toISOString())
          if (
            this.hasAlertMedia(popup.alert) &&
            (this.hasNewModalMediaAlert || !this.hasScopeMultiEvidence)
          ) {
            this.getDetailedVideo(popup.alert)
          }
        }

        if (popup.note) {
          this.handleNoteInput(popup.id, popup.note)
        }
      })
    }
    let listCompany = []
    if (this.companyList == undefined) {
      this.isAllowed = true
    } else {
      listCompany = this.companyList.split(',')
      this.isAllowed = listCompany.includes(this.companyId.toString())
    }

    this.adjustImageSize()
    if (this.$store.state.config.systemNotification && this.hasAccess('system_notification:read')) {
      this.getTotalUnread()
    }
    // Note: startWebSocket() removed - websocket is already initialized by App.vue or initWebSocket() above
    // No need to call it again here, preventing duplicate update_tags messages

    setInterval(() => {
      if (this.top3alert.length > 0) {
        this.currentCarouselIndex = (this.currentCarouselIndex + 1) % 3
      }
    }, 3000)
    EventBus.$on('handle-open-popup', this.handleNavbarPopup)
    EventBus.$on('handle-close-popup', this.closePopup)
    EventBus.$on('show-onboarding', this.showOnboarding)
    if (this.hasUrgentScope) {
      this.$root.$on('urgent-unresolved', (val) => {
        this.hasUrgentUnresolved = val
      })
    }
  },

  beforeDestroy() {
    this.forceDisconnect = true
    // Unregister handler
    if (this.wsMessageHandler) {
      this.$store.dispatch('ws/unregisterMessageHandler', this.wsMessageHandler)
    }
    if (this.pollTimeout) clearTimeout(this.pollTimeout)
  },

  destroyed() {
    // DO NOT disconnect websocket when handlers reach 0
    // The websocket should stay alive during the entire session
    // Other components (like Control Tower) may still need it
    // Only disconnect on explicit logout
    clearInterval(this.pongInterval)
  },

  methods: {
    refreshAlertSubscriptions() {
      if (this.alertSubscriptionsRefreshPromise) {
        this.alertSubscriptionsRefreshQueued = true
        return this.alertSubscriptionsRefreshPromise
      }

      this.alertSubscriptionsRefreshPromise = this.$apollo.queries.getPayload
        .refetch()
        .then((response) => {
          const getPayload = response?.data?.getPayload
          const payload = getPayload?.payload?.payload
          if (
            getPayload?.isSuccessful &&
            payload &&
            this.$store.state.ws.socket.isConnected &&
            this.$socket?.readyState === 1
          ) {
            this.$socket.sendObj({
              type: 'update_tags',
              data: payload,
            })
          }
        })
        .catch((error) => {
          // Keep the current rules and socket tags when synchronization fails.
          // eslint-disable-next-line no-console
          console.warn('Failed to refresh alert subscriptions:', error)
        })
        .finally(() => {
          this.alertSubscriptionsRefreshPromise = null
          if (this.alertSubscriptionsRefreshQueued) {
            this.alertSubscriptionsRefreshQueued = false
            this.refreshAlertSubscriptions()
          }
        })

      return this.alertSubscriptionsRefreshPromise
    },

    hasVgroupItems(popupId) {
      return (this.popupVgroupItemsMap[popupId] || []).length > 0
    },
    getAlertTexts(alert) {
      if (!alert.alertRuleIds || !Array.isArray(alert.alertRuleIds)) {
        return []
      }

      const filterAlertRuleList = alert.alertRuleIds
        .map((id) => this.allRulesObj[id])
        .filter((rule) => rule)

      return filterAlertRuleList
    },
    getAlertTooltipText(alert) {
      return this.getAlertTexts(alert)
        .map((rule) => rule.label)
        .join('\n')
    },
    async initWebSocket() {
      const obj = {
        type: `update_tags`,
        data: this.internalPayload,
      }

      if (!obj.data && !this.internalPayload) {
        await this.$apollo.queries.getPayload.refetch()
        obj.data = this.internalPayload
      }

      // Connect only if not already connected
      if (!this.$store.state.ws.socket.isConnected) {
        await this.$store.dispatch(
          'ws/WSConnect',
          `${process.env.VUE_APP_WS_URL}/ws?token=${localStorage.getItem('wsToken')}`
        )

        // Wait for connection
        await new Promise((resolve) => {
          const timeout = setTimeout(() => {
            resolve()
          }, 10000)

          const checkConnection = setInterval(() => {
            if (this.$store.state.ws.socket.isConnected) {
              clearInterval(checkConnection)
              clearTimeout(timeout)
              resolve()
            }
          }, 100)
        })
      }

      // Send update tags if connected
      if (
        this.$store.state.ws.socket.isConnected &&
        this.$socket &&
        this.$socket.readyState === 1
      ) {
        this.$socket.sendObj(obj)
      }
    },

    handleWebSocketMessage(message) {
      // Parse message if it's a string
      const signal = typeof message === 'string' ? JSON.parse(message) : message

      if (signal.type === 'PONG') {
        this.lastPong = moment()
        this.handlePong()
        return
      }

      if (!Object.prototype.hasOwnProperty.call(signal, 'type')) return

      const userId = this.getUserId()
      const companyId = this.getCompanyId()

      // Handle alert resolution
      if (signal.type === `alert-center-resolve-${companyId}`) {
        this.resolveAlertByWs(signal.payload)
      } else if (signal.type === `alert-center-feedback-${companyId}`) {
        this.handleAlertFeedbackByWs()
      } else if (
        signal.type.startsWith('alert-center-') &&
        signal.payload.companyId === companyId
      ) {
        // Handle alert updates
        this.setAlertList(signal.payload)
      } else if (signal.type === `system-notif-${userId}`) {
        // Handle system notifications
        const audio = new Audio(soundNotification)
        audio.play()
        this.showNotifToast(signal.payload)
      } else if (signal.type === `alert-center-new-${userId}`) {
        // Handle new alert rules
        this.showNewAlertRulesToast()
        this.refreshAlertSubscriptions()
      }
      // Handle DVH updates
      else if (signal.type.startsWith('dvh-')) {
        this.handleDvhUpdate(signal.payload)
      }
    },

    handleDvhUpdate(dataDvh) {
      if (!dataDvh || !['S', 'F'].includes(dataDvh.status)) return

      const dataDvhRequested = this.$store.state.notification.dataDvhRequested
      const listNotificationMedia = this.$store.state.notification.listNotificationMedia
      const detailNotification = this.$store.state.notification.detailNotification
      const alertList = this.$store.state.notification.alertList

      const requestedItem = dataDvhRequested.find((d) => d.downloadId === dataDvh.downloadId)
      const listNotificationItem = listNotificationMedia.find(
        (d) => d.downloadId === dataDvh.downloadId
      )
      const popup = this.activePopups.find((item) =>
        item.alert?.media?.some((media) => media.downloadId === dataDvh.downloadId)
      )
      const alert = alertList.find((item) =>
        item.media?.some((media) => media.downloadId === dataDvh.downloadId)
      )
      const isDetailMatch = detailNotification?.media?.some(
        (media) => media.downloadId === dataDvh.downloadId
      )

      if (!requestedItem && !listNotificationItem && !popup && !alert && !isDetailMatch) return

      if (requestedItem) {
        this.$store.commit('notification/updateDataDvhRequested', {
          downloadId: dataDvh.downloadId,
          data: dataDvh,
        })
      }

      if (listNotificationItem) {
        this.$store.commit('notification/updateDataListNotificationMedia', {
          downloadId: dataDvh.downloadId,
          data: dataDvh,
        })
      }

      const alertId =
        requestedItem?.rawAlertId ||
        (isDetailMatch ? detailNotification?.rawAlertId : null) ||
        popup?.alert?.rawAlertId ||
        alert?.rawAlertId ||
        alert?.id

      if (!alertId) return

      if (dataDvh.status === 'S' && dataDvh.url) {
        this.$store.dispatch('notification/setMediaPollingState', {
          id: alertId,
          pollingStatus: 'complete',
          canCheck: false,
          canRequest: false,
          videoData: dataDvh,
        })
      } else if (dataDvh.status === 'F') {
        const fallbackAlert = popup?.alert || alert || detailNotification
        const fallbackMedia = [
          listNotificationMedia,
          popup?.alert?.media || [],
          alert?.media || [],
          detailNotification?.media || [],
        ]
          .flat()
          .filter(
            (media) =>
              media.startTime &&
              fallbackAlert?.createdOn &&
              new Date(media.startTime).getTime() === new Date(fallbackAlert.createdOn).getTime()
          )
        const fallbackVideoData = this.findAlertHistoryMedia(fallbackMedia)

        if (fallbackVideoData?.url) {
          this.$store.dispatch('notification/setMediaPollingState', {
            id: alertId,
            pollingStatus: 'complete',
            canCheck: false,
            canRequest: false,
            retryCount: 0,
            videoData: fallbackVideoData,
            isOfflineDevice: false,
          })
          return
        }

        this.$store.dispatch('notification/setMediaPollingState', {
          id: alertId,
          pollingStatus: 'timeout',
          canCheck: false,
          canRequest: true,
          retryCount: 0,
          videoData: null,
          isOfflineDevice: false,
        })
      }
    },

    isAlertUrgent(formattedAlert) {
      const hasUrgentRules = this.alertRuleIds?.urgentAlertRules
      const hasAlertRuleIds = formattedAlert.alertRuleIds
      const hasMatchingRule =
        hasAlertRuleIds &&
        formattedAlert.alertRuleIds.some((ruleId) =>
          this.alertRuleIds.urgentAlertRules.includes(ruleId)
        )

      const result = hasUrgentRules && hasAlertRuleIds && hasMatchingRule

      return result
    },
    isAlertImportant(formattedAlert) {
      if (this.isAlertUrgent(formattedAlert)) {
        return false
      }

      const hasImportantRules = this.alertRuleIds?.importantAlertRules
      const hasAutoPopupRules = this.alertRuleIds?.autoPopupAlertRules
      const hasAlertRuleIds = formattedAlert.alertRuleIds

      const hasMatchingImportantRule =
        hasAlertRuleIds &&
        formattedAlert.alertRuleIds.some((ruleId) =>
          this.alertRuleIds.importantAlertRules.includes(ruleId)
        )

      const hasMatchingAutoPopupRule =
        hasAlertRuleIds &&
        formattedAlert.alertRuleIds.some((ruleId) =>
          this.alertRuleIds.autoPopupAlertRules.includes(ruleId)
        )
      const result =
        (hasImportantRules && hasMatchingImportantRule) ||
        (hasAutoPopupRules && hasMatchingAutoPopupRule)

      return result
    },
    ...mapActions('announcement', [
      'incrementUnreadAnnouncement',
      'decrementUnreadAnnouncement',
      'resetUnreadAnnouncement',
      'setInitialUnreadAnnouncement',
    ]),

    ...mapActions({
      showNewAlertRulesToast: 'notification/showNewAlertRulesToast',
    }),

    generateGMapType() {
      if (this.hasAccess(['e4d-alert-center-embed-map:read']))
        this.$store.commit('map/setDefaultMap', 'Embed')
      else this.$store.commit('map/setDefaultMap', 'Static')
    },

    setFalseAlertReason(popupId, reason) {
      this.$store.dispatch('notification/updatePopupForm', {
        id: popupId,
        formData: createAlertActionForm({ reason }),
      })
    },

    getFalseAlertActionHandlers(popup) {
      return createFalseAlertActionHandlers({
        openActionModal: (type) => this.openActionModal(popup, type),
        markAsResolved: (status, actionType) => this.markAsResolved(popup, status, actionType),
        setFormOpen: (formOpen) => this.setFormOpen(popup.id, formOpen),
        setFalseAlertReason: (reason) => this.setFalseAlertReason(popup.id, reason),
      })
    },

    showNotifAction(item) {
      this.showDetailAction(item)
      if (!item.is_read) {
        this.updateRead(item.system_notification_uuid)
      }
    },

    async showDetailAction(sysNotif) {
      await this.getSystemNotificationDetail(sysNotif.system_notification_uuid)
      if (this.listNotifAction.includes(this.notifAction)) {
        this.$bvModal.show('modal-notif-action')
      } else if (this.notifAction === 'external_link') {
        window.open(this.notifData.data, '_blank')
      } else if (this.notifAction === 'internal_link') {
        const resolvedUrl = this.$router.resolve(this.notifData.data).href
        window.open(resolvedUrl, '_blank')
      }
      this.showModalNotif = !this.showModalNotif
      this.mixpanelNotif('Click System Notif Detail')
    },

    async getSystemNotificationDetail(sysNotifUuid) {
      this.isLoading = true
      const systemNotif = await systemNotification.get(sysNotifUuid)
      if (!systemNotif?.data) {
        this.isLoading = false
        return
      }
      this.notifAction = systemNotif.data.action
      this.notifData = systemNotif.data.data
      this.isLoading = false
    },

    async updateRead(sysNotifUuid) {
      this.render = true
      const data = {
        is_read: true,
        updated_on: new Date(),
      }
      if (sysNotifUuid) {
        this.decrementUnreadAnnouncement()
        data.system_notification_uuid = sysNotifUuid
      } else {
        this.resetUnreadAnnouncement()
      }
      await systemNotificationUser.update(data)
      this.getSystemNotificationUser()
      this.render = false
    },

    foData(data) {
      switch (data.alertCode) {
        case 137:
          return [
            { title: 'notification.text.taskLocation', value: data.foData.detail.location || '-' },
          ]
        case 138:
          return [
            {
              title: 'notification.text.totalFoDuration',
              value: this.msToHours(data.foData.detail.total_fo_duration, 'iso8601') || '-',
            },
          ]
        case 139:
          return [
            {
              title: 'notification.text.targetArrival',
              value: this.timeWithLabelAndShortDate(data.foData.detail.target_time) || '-',
            },
            {
              title: 'notification.text.actualArrival',
              value: this.timeWithLabelAndShortDate(data.foData.detail.actual_time) || '-',
            },
          ]
        case 140:
          return [
            {
              title: 'notification.text.targetDeparture',
              value: this.timeWithLabelAndShortDate(data.foData.detail.target_time) || '-',
            },
            {
              title: 'notification.text.actualDeparture',
              value: this.timeWithLabelAndShortDate(data.foData.detail.actual_time) || '-',
            },
          ]
        case 141:
        case 142:
          return [
            {
              title: 'notification.text.destination',
              value: data.foData.detail.point_location_name || '-',
            },
            {
              title: 'notification.text.distanceToDestination',
              value: data.foData.detail.point_in_km || '-',
            },
            {
              title: 'notification.text.arrivalToLocationTarget',
              value: this.timeWithLabelAndShortDate(data.foData.detail.target_time) || '-',
            },
            {
              title: 'notification.text.arrivalToLocationEstimation',
              value:
                this.timeWithLabelAndShortDate(data.foData.detail.estimated_target_time) || '-',
            },
          ]
        case 143:
          return [
            {
              title: 'notification.text.taskLocation',
              value: data.foData.detail.point_location_name || '-',
            },
            {
              title: 'notification.text.activityTargetDuration',
              value:
                this.msToHours(data.foData.detail.planned_activities_duration, 'iso8601') || '-',
            },
          ]
        default:
          return false
      }
    },

    async startWebSocket() {
      const obj = {
        type: `update_tags`,
        data: this.internalPayload,
      }

      if (!obj.data && !this.internalPayload) {
        await this.$apollo.queries.getPayload.refetch()
        obj.data = this.internalPayload
      }

      // Connect only if not already connected
      if (!this.$store.state.ws.socket.isConnected) {
        await this.$store.dispatch(
          'ws/WSConnect',
          `${process.env.VUE_APP_WS_URL}/ws?token=${localStorage.getItem('wsToken')}`
        )

        // Wait for connection
        await new Promise((resolve) => {
          const timeout = setTimeout(() => {
            resolve()
          }, 10000)

          const checkConnection = setInterval(() => {
            if (this.$store.state.ws.socket.isConnected) {
              clearInterval(checkConnection)
              clearTimeout(timeout)
              resolve()
            }
          }, 100)
        })
      }

      // Send update tags if connected
      if (
        this.$store.state.ws.socket.isConnected &&
        this.$socket &&
        this.$socket.readyState === 1
      ) {
        this.$socket.sendObj(obj)
      }
    },

    // 🧠 Called from WebSocket PONG handler
    handlePong() {
      this.pongCounter++

      // Check for updates every 3 PONGs
      if (this.pongCounter >= 3) {
        this.pongCounter = 0 // Reset counter
        // Only check if we're not already checking and no update is pending
        if (!this.isCheckingSW && !this.updateDetected) {
          this.isCheckingSW = true

          this.checkServiceWorkerUpdate()
            .catch((error) => {
              // eslint-disable-next-line no-console
              console.error('Error in checkServiceWorkerUpdate:', error)
            })
            .finally(() => {
              // eslint-disable-next-line no-console
              this.isCheckingSW = false
            })
        }
      }
    },

    // 🧮 Format timer display (MM:SS)
    formatCountdown() {
      const m = Math.floor(this.refreshCountdown / 60)
      const s = this.refreshCountdown % 60
      return `${m}:${s.toString().padStart(2, '0')}`
    },

    // 🔌 WebSocket setup
    setUpSocketListeners() {
      this.$socket.onmessage = (data) => {
        const signal = JSON.parse(data.data)

        if (signal.type === 'PONG') {
          this.lastPong = moment()
          this.handlePong()
          return
        }

        if (Object.prototype.hasOwnProperty.call(signal, 'type')) {
          const userId = this.getUserId()
          const companyId = this.getCompanyId()

          if (signal.type === `alert-center-resolve-${companyId}`) {
            this.resolveAlertByWs(signal.payload)
          }
          if (signal.type.startsWith('alert-center-') && signal.payload.companyId === companyId) {
            this.setAlertList(signal.payload)
          }
          if (signal.type === `system-notif-${userId}`) {
            const audio = new Audio(soundNotification)
            audio.play()
            this.showNotifToast(signal.payload)
          }
          if (signal.type === `alert-center-new-${userId}`) {
            this.showNewAlertRulesToast()
            this.refreshAlertSubscriptions()
          }
        }
      }

      this.$socket.onclose = async () => {
        if (this.forceDisconnect) return
      }
    },

    showNotifToast(payload) {
      this.$bvModal.hide('modal-notif')
      this.incrementUnreadAnnouncement()
      this.$mcToastNotif({
        component: 'McToastNotifDynamicBody',
        props: {
          payload: payload,
          payloadHeader: this.$t('navbar.notif.newAnnouncement'),
          navbar: this,
        },
      })
    },

    async getTotalUnread() {
      const unread = await systemNotificationUser.unread()
      if (!unread?.data) return
      this.$store.dispatch('announcement/setInitialUnreadAnnouncement', unread.data)
    },

    statusDate(createdOn) {
      return moment(createdOn).fromNow()
    },

    async showNotif() {
      // dummy call function notif toast
      // this.showNotifToast()
      this.$bvModal.show('modal-notif')
      this.render = !this.render
      await this.getSystemNotificationUser()
      this.render = !this.render
      this.mixpanelNotif('Click System Notif')
    },

    async systemNotifScroll() {
      if (!this.isLoading) {
        const scrollContainer = this.$refs.scrollContainer
        if (
          scrollContainer.scrollTop + scrollContainer.clientHeight >=
          scrollContainer.scrollHeight
        ) {
          if (this.limit < this.totalCount) {
            this.isLoading = true // Menandai bahwa proses sedang berjalan
            try {
              this.limit += 10
              if (this.limit > this.totalCount) {
                this.limit = this.totalCount
              }
              await this.getSystemNotificationUser()
            } finally {
              this.isLoading = false // Mengembalikan penanda setelah proses selesai
            }
          }
        }
      }
    },

    async getSystemNotificationUser() {
      this.isLoading = true
      const params = {
        limit: this.limit,
        page: 1,
      }
      let userId = this.getUserId()
      const systemNotifUser = await systemNotificationUser.get(params, userId)
      if (!systemNotifUser?.data) {
        this.isLoading = false
        return
      }
      this.listNotif = systemNotifUser.data.paginated_result
      this.totalCount = systemNotifUser.metadata.total_count
      this.isLoading = false
    },

    status(e) {
      this.onLine = e
      setTimeout(() => {
        if (e) {
          window.location.reload()
        }
      }, 300)
    },
    toggleMenu() {
      this.$parent.toggleMenu()
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar()
    },
    initFullScreen() {
      document.body.classList.toggle('fullscreen-enable')
      if (
        !document.fullscreenElement &&
        /* alternative standard method */ !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen()
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen()
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT)
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen()
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen()
        }
      }
    },
    setLanguage(locale) {
      i18n.locale = locale
      this.language = locale
      localStorage.setItem('language', i18n.locale)
    },
    logoutUser() {
      // eslint-disable-next-line no-unused-vars
      axios.get('http://127.0.0.1:8000/api/logout').then((res) => {
        this.$router.push({
          name: 'default',
        })
      })
    },
    async logout() {
      try {
        // Make sure the fireabase app is initialized
        const app = this.getFirebaseApp('vsmsNotif')
        const messaging = getMessaging(app)

        // Attemp to delete FCM Token
        await this.deleteFCMToken(messaging)

        // Unregister FCM token from the backend
        if (this.getFeatureFlagValue('fcmTopicDeliveries')) {
          await this.unregisterTokenFromBackend()
        }
        // Unregister FCM service workers
        await unregisterFCMServiceWorkers(navigator)

        // Toggle account settings and delete Firebase app instance
        this.toggleAccount()
        if (app) await deleteApp(app)

        // Redirect to logout URL
        this.redirectToLogout()
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error during logout:', error)

        // Fallback redirect to logout URL in case of errors
        this.redirectToLogout()
      }
    },
    getFirebaseApp(appName) {
      try {
        return getApp(appName)
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(`Firebase app '${appName}' is not initialized.`, error)
        throw error
      }
    },
    async deleteFCMToken(messaging) {
      try {
        const result = await deleteToken(messaging)
        if (!result) {
          // eslint-disable-next-line no-console
          console.warn('Failed to delete registration token')
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error deleting FCM token:', error)
      }
    },
    async unregisterTokenFromBackend() {
      const fcmToken = localStorage.getItem('fcmToken')
      if (!fcmToken) return

      try {
        await this.$apollo.mutate({
          mutation: UNREGISTER_FCM_TOKEN,
          variables: {
            input: {
              registrationToken: fcmToken,
              platform: 'web',
            },
          },
        })
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error unregistering FCM token from backend:', error)
      }
    },
    redirectToLogout() {
      setTimeout(() => {
        location.href = `${process.env.BASE_URL}logout`
      }, 500)
    },
    toggleAccount() {
      this.dropDownAccount = !this.dropDownAccount
    },
    cancelToVsms1() {
      this.selectedVsms1 = false
      this.reasonToVsms1 = false
      this.$refs['modal-vsms1'].hide()
    },
    goToVsms1() {
      var msg = ''
      if (this.selectedVsms1 == false) {
        this.reasonToVsms1 = false
        this.$refs['modal-vsms1'].hide()
      }
      if ((this.otherReasonVsms1 == '' && this.reasonToVsms1 == 4) || this.reasonToVsms1 == null) {
        return Swal.fire({
          title: 'Wajib Memilih Alasan',
          text: 'Silahkan pilih alasan Anda ingin kembali menggunakan VSMS 1.0',
          imageUrl: require(`@/assets/images/alert-report-danger.png`),
          showCloseButton: true,
          showConfirmButton: false,
        })
      } else {
        if (this.reasonToVsms1 == 4) {
          msg = this.otherReasonVsms1
        } else {
          msg = this.options[this.reasonToVsms1].text
        }
        const input = {
          message: msg,
        }
        this.$apollo
          .mutate({
            mutation: VSMS_V1,
            variables: {
              input: input,
            },
          })
          .then((response) => {
            if (response.data.backToVsmsV1.isSuccessful) {
              try {
                const app = getApp('vsmsNotif')
                if (app) {
                  deleteApp(app)
                }
                setTimeout(() => {
                  localStorage.removeItem('token')
                  localStorage.removeItem('domainName')
                  localStorage.removeItem('domainNameExpired')
                  localStorage.removeItem('payload')
                  location.href = 'https://' + response.data.backToVsmsV1.backToVsmsV1.message
                }, 500)
              } catch (e) {
                setTimeout(() => {
                  localStorage.removeItem('token')
                  localStorage.removeItem('domainName')
                  localStorage.removeItem('domainNameExpired')
                  localStorage.removeItem('payload')
                  location.href = 'https://' + response.data.backToVsmsV1.backToVsmsV1.message
                }, 500)
              }
            }
          })
      }
    },
    adjustImageSize() {
      this.resizeImage(this.$refs.imgPrimaryLogoMax, 40, 125)
      this.resizeImage(this.$refs.imgPrimaryLogoMin, 40, 40)
    },
    closeAccountDropdown(evt) {
      // If there is no event, it means we are clicking the buttons inside the dropdown
      // function "toggleAccount" will take care of it
      if (!evt) return
      this.dropDownAccount = false
    },
    mixpanelWishForm() {
      this.track('View Wishlist Form', {
        user_name: this.$store.state.identity.whoami?.name,
        email: this.$store.state.identity.whoami?.email,
      })
    },
    mixpanelNotif(event) {
      this.track(event, {
        user_name: this.$store.state.identity.whoami?.name,
        email: this.$store.state.identity.whoami?.email,
        company_name: this.$store.state.identity.whoami?.companyName,
        access_right: this.$store.state.identity.whoami?.accessRight,
      })
    },
    showAlertCenter() {
      this.track('Click Notification Icon')
      if (
        this.$store.state.sidebar.notifSideBarOpen ||
        localStorage.getItem('notifSideBarOpen') ||
        this.$store.state.notification.popupState.alertCenterPopup
      ) {
        this.$store.commit('sidebar/toggleNotifSideBar', false)
        this.$store.commit('notification/setPopupState', { alertCenterPopup: false })
        localStorage.removeItem('notifSideBarOpen')
        document.body.classList.remove('notification-center')
      } else {
        this.alertCenterVisible = !this.alertCenterVisible
        this.top3alert = []
      }
    },

    async handleNavbarPopup(alertId) {
      const alert = await this.handleOpenPopup(alertId, {
        enrichAlert: this.enrichNavbarAlert,
      })
      if (!alert) return
      this.setSelectedAlert(alert)
      if (
        this.hasAlertMedia(alert) &&
        (this.hasNewModalMediaAlert || !this.hasScopeMultiEvidence)
      ) {
        await this.getDetailedVideo(alert)
      }
    },

    async enrichNavbarAlert(alert) {
      let enrichment = {}
      if (this.hasFleetTaskInstantScope && this.isFO(alert)) {
        try {
          const alertData = alert.alertData.split('|')
          const foNumber = alertData[0]
          const foId = alertData[1]
          const logId = alertData[2]

          const res = await FleetTaskInstant.getLogDetail(foId, logId)
          enrichment = {
            foNumber,
            foId,
            logId,
            foData: res.data || null,
          }
        } catch (error) {
          enrichment = { foData: null }
        }
      }

      const callState = await this.getCallState(alert)
      return {
        ...alert,
        ...enrichment,
        callState,
      }
    },

    async getCallState(alert) {
      const dataTv = alert?.vehicle

      const isHaveChildren = dataTv?.children?.length > 0
      let deviceType = this.getDeviceType(dataTv?.device?.deviceCode)
      let imeiVoip = dataTv?.imei
      let vehicleIdVoip = alert.vehicleId
      if (isHaveChildren) {
        deviceType = this.getDeviceType(dataTv?.children[0]?.device?.deviceCode)
        imeiVoip = dataTv?.children[0]?.imei
        vehicleIdVoip = dataTv?.children[0]?.id
      }

      const isHaveVoip = deviceType === 'bsj' || deviceType === 'vss-howen'

      const callState = {
        isHaveVoip,
        deviceType,
        imeiVoip,
        vehicleIdVoip,
      }
      return callState
    },
    async getDataTrackvision(vehicleIdCam) {
      try {
        const response = await this.$apollo.query({
          query: GET_VEHICLE_TV_DATA,
          fetchPolicy: 'no-cache',
          variables: {
            filter: {
              id: vehicleIdCam,
            },
          },
        })
        const dataTv = response.data?.vehicle?.vehicle ?? null
        return dataTv
      } catch (err) {
        console.error(err)
        return null
      }
    },
    setFormOpen(popupId, state) {
      this.$store.dispatch('notification/openPopupForm', {
        id: popupId,
        formOpen: state,
      })
    },
    handleFormChange(popupId, value) {
      this.$store.dispatch('notification/updatePopupForm', {
        id: popupId,
        formData: createAlertActionForm(value),
      })
    },

    handleNotesBilingual(value) {
      return normalizeAlertNote(value, this.$t.bind(this))
    },

    getPopupActionContext(popup, { note = popup.note } = {}) {
      return createAlertActionContext({
        apollo: this.$apollo,
        store: this.$store,
        alert: popup.alert,
        popupId: popup.id,
        note,
        form: popup.form,
        t: this.$t.bind(this),
        toast: this.$mcToast,
        track: (event, data) => this.track(event, data),
        fullname: this.$store.state.access.profile.fullname,
        trackLocation: 'Preview',
        alertName:
          this.language == 'en'
            ? popup.alert.alert.descriptionEng
            : popup.alert.alert.descriptionIdn,
      })
    },

    async saveFalseAlert(popup, isFalseAlert, actionType) {
      const isSuccess = await saveFalseAlertAction(this.getPopupActionContext(popup), {
        isFalseAlert,
        actionType,
      })

      if (!isSuccess) return false

      this.refreshVisibleUnresolvedAccordion()
      this.refreshAlertCenterCounts()
      this.setFormOpen(popup.id, false)

      if (popup.alert?.isCDMAlert) {
        EventBus.$emit('refetch-cdm-alert-code')
      }

      return true
    },

    handleNoteInput: debounce(function (popupId, value) {
      const bilingualNotes = this.handleNotesBilingual(value)
      this.$store.dispatch('notification/updatePopupNote', {
        id: popupId,
        note: bilingualNotes,
      })
    }, 500),

    openQADetail(alert) {
      const id = alert.alertData.split('|')[1]
      this.$router.replace({ name: 'Fleet Task Instant Detail', params: { id } })
    },

    handleModalAction() {
      switch (this.modalType) {
        case 'falseAlert':
          this.saveFalseAlert(this.selectedPopup, true, 'FalseAlert')
          break
        case 'recheck':
          this.saveFalseAlert(this.selectedPopup, false, 'FalseAlert')
          break
        case 'resolved':
          this.markAsResolved(this.selectedPopup, false, 'Resolve')
          break
      }
    },

    showActionModal(popup, type) {
      this.selectedPopup = popup
      this.modalType = type
      this.$bvModal.show('modal-alert-action')
    },

    waitModalHidden(modalId) {
      return waitModalHidden(this.$root, modalId)
    },

    openActionModal(popup, type) {
      const modalHidden = this.waitModalHidden('modal-alert-action')
      this.showActionModal(popup, type)
      return modalHidden
    },

    async saveNote(popup) {
      const submittedNote = this.handleNotesBilingual(popup.note)
      const isSuccess = await saveAlertNoteAction(
        this.getPopupActionContext(popup, { note: submittedNote }),
        {
          isFalseAlert: Boolean(popup.alert.isFalseAlert),
        }
      )

      if (!isSuccess) return false

      this.$store.dispatch('notification/updatePopupNote', {
        id: popup.id,
        note: '',
      })

      if (popup.alert?.isCDMAlert) {
        EventBus.$emit('refetch-cdm-alert-code')
      }

      return true
    },
    closePopup(alertId) {
      const notification = this.activePopups.find((n) => n.id === alertId)
      this.track('Click Close Notification Preview', {
        'license-plate': notification.alert?.licensePlate,
        'notification-name':
          this.language == 'en'
            ? notification.alert.alert.descriptionEng
            : notification.alert.alert.descriptionIdn,
      })

      this.$store.dispatch('notification/closePopup', alertId)
    },

    getAlertMediaVehicleId(alert) {
      const childId = alert?.vehicle?.children[0]?.id
      return childId || alert.vehicleId
    },

    hasAlertMedia(alert) {
      return this.hasMedia(alert) || this.hasCaptureEventMedia(alert) || this.isBsdAlert(alert)
    },

    findAlertHistoryMedia(mediaList) {
      return (
        mediaList.find((data) => data.status === 'S' && data.identifier === 'V') ||
        mediaList.find((data) => data.status === 'S' && data.identifier === 'P') ||
        mediaList.find((data) => data.status === 'S' && data.identifier === 'C')
      )
    },

    // this function loads media history for DMS/ADAS and capture event alerts
    async getDetailedVideo(alert) {
      const isCaptureEventMedia = this.hasCaptureEventMedia(alert)
      const minutesSinceAlert = (Date.now() - new Date(alert.createdOn)) / 60000
      const daysSinceAlert = (Date.now() - new Date(alert.createdOn)) / (1000 * 60 * 60 * 24)

      if (alert.media?.length) {
        const dvh = this.findAlertHistoryMedia(alert.media)

        if (dvh) {
          return this.setPollingStatus(alert, 'complete', { videoData: dvh })
        }

        const pendingDvh = alert.media.find(
          (data) => data.status === 'I' && ['V', 'P'].includes(data.identifier)
        )

        if (pendingDvh) {
          this.setPollingStatus(alert, 'checking')
          this.pollForVideo(alert)
          return
        }
      }

      if (daysSinceAlert > MEDIA_EXPIRY_DAYS) {
        return this.setPollingStatus(alert, 'failed')
      }

      if (minutesSinceAlert >= MEDIA_POLL_THRESHOLD_MINUTES || isCaptureEventMedia) {
        return this.setPollingStatus(alert, 'timeout', { canRequest: true })
      }

      if (alert.pollingStatus === undefined) {
        this.setPollingStatus(alert, 'loading')
        this.pollForVideo(alert)
      }
    },

    async refreshMediaUrl(alert) {
      const currentMedia = alert.videoData

      try {
        const response = await this.getAlertDetail(alert.rawAlertId || alert.id)
        const rawAlert = response?.data?.rawAlert
        const media = rawAlert?.rawAlert?.media || []
        const refreshedMedia =
          media.find((item) => item.downloadId === currentMedia?.downloadId) ||
          media.find((item) => item.mediaFilename === currentMedia?.mediaFilename)

        if (
          rawAlert?.isSuccessful &&
          refreshedMedia?.url &&
          refreshedMedia.url !== currentMedia?.url
        ) {
          this.setPollingStatus(alert, 'complete', { videoData: refreshedMedia })
          return
        }
      } catch (error) {
        this.setPollingStatus(alert, 'timeout', { canRequest: true, videoData: null })
        return
      }

      this.setPollingStatus(alert, 'timeout', { canRequest: true, videoData: null })
    },

    pollForVideo(alert) {
      const alertDate = new Date(alert.createdOn)
      const vehicleIdCam = this.getAlertMediaVehicleId(alert)
      const isTimedOut = () => (Date.now() - alertDate) / 60000 >= MEDIA_POLL_THRESHOLD_MINUTES
      let retryCount = 0
      let timeoutId = null

      const cancel = () => {
        if (timeoutId) {
          clearTimeout(timeoutId)
          timeoutId = null
        }
      }
      this.$set(alert, '_cancelPolling', cancel)

      const stopPolling = () => {
        cancel()
        this.$set(alert, '_cancelPolling', null)
      }

      return new Promise((resolve) => {
        const poll = async () => {
          try {
            const res = await this.getDownloadVideoHistoriesByEvent(vehicleIdCam, alert.createdOn)
            const mediaList =
              res?.data?.findDownloadVideoHistories?.findDownloadVideoHistories?.data || []
            const dvh = this.findAlertHistoryMedia(mediaList)

            if (dvh) {
              stopPolling()
              this.setPollingStatus(alert, 'complete', { videoData: dvh })
              return resolve(true)
            }

            retryCount++
            if (retryCount < MEDIA_POLL_MAX_RETRY) {
              this.setPollingStatus(alert, 'checking', { canCheck: true, retryCount })
              timeoutId = setTimeout(poll, MEDIA_POLL_RETRY_INTERVAL_MS)
              return
            }

            stopPolling()
            const timedOut = isTimedOut()
            this.setPollingStatus(alert, timedOut ? 'timeout' : 'waiting', {
              canCheck: !timedOut,
              canRequest: timedOut,
              retryCount: timedOut ? 0 : retryCount,
            })
            resolve(false)
          } catch (error) {
            console.error('pollForVideo error:', error)
            stopPolling()
            const timedOut = isTimedOut()
            this.setPollingStatus(alert, timedOut ? 'timeout' : 'failed', {
              canRequest: timedOut,
            })
            resolve(false)
          }
        }
        poll()
      })
    },

    async startReqMedia(alert) {
      const vehicleIdCam = this.getAlertMediaVehicleId(alert)

      this.setPollingStatus(alert, 'requesting', { canRequest: true })

      const vehicleStatusCam = await this.getVehicleStatusByVehicleId(vehicleIdCam)
      const lastReceive = vehicleStatusCam.lastReceive
      const diffMinutes = this.getDurationBetween2Dates(lastReceive, this.now())
      const checkDeviceOffline = diffMinutes > 10 ? true : false
      if (checkDeviceOffline) {
        this.$mcToast.error(this.$t('notification.text.deviceUnreachable'))
        this.setPollingStatus(alert, 'timeout', { canRequest: true, isOfflineDevice: true })
        return false
      }

      try {
        const alertType = getAlertMediaRequestType(alert)
        if (!alertType) return false
        await this.requestUpdateFileList(alert, alertType, vehicleStatusCam.vehicle.imei)
        await this.delay(5000)
        await this.requestVideo(alert, alertType, vehicleStatusCam.vehicle.imei)
        return true
      } catch (error) {
        this.setPollingStatus(alert, 'timeout', { canRequest: true })
        // eslint-disable-next-line no-console
        console.error('Request failed:', error)
        return false
      }
    },

    async getDownloadVideoHistoriesByEvent(vehicleId, startTime) {
      const response = await this.$apollo.query({
        query: FIND_DOWNLOAD_VIDEO_HISTORIES_FOR_NOTIFICATION_MEDIA,
        fetchPolicy: 'no-cache',
        variables: {
          filter: {
            startTime: startTime,
            vehicleId: vehicleId,
            pagination: {
              page: 1,
              show: 9999,
            },
          },
        },
      })
      return response
    },

    async requestUpdateFileList(alert, alertType, imei) {
      let input

      const rawAlertCreatedOn = alert.createdOn
      const rawAlertMoment = moment.utc(rawAlertCreatedOn)
      const now = moment.utc()
      const startRange = rawAlertMoment.clone().subtract(6, 'hours')
      const endRangeCandidate = rawAlertMoment.clone().add(6, 'hours')
      const endRange = moment.min(endRangeCandidate, now)

      input = {
        imei,
        useInMemoryDB: true,
        dateRange: { start: startRange, end: endRange },
      }

      const isDmsAdas = this.hasMedia(alert)

      if (isDmsAdas) {
        input.alertCategory = alertType.toUpperCase()
      }

      const isBsd = this.isBsdAlert(alert)

      if (isBsd) {
        input.alertCategory = alertType.toUpperCase()
      }

      const isCaptureEvent = this.hasCaptureEventMedia(alert)

      if (isCaptureEvent) {
        input.channel = 1
      }

      await this.$apollo.mutate({
        mutation: UPDATE_FILELIST,
        variables: {
          input: input,
        },
        fetchPolicy: 'no-cache',
      })
    },

    async requestVideo(alert, alertType, imei) {
      if (!alertType) return
      let startTime, endTime
      startTime = moment(alert.createdOn).clone().subtract(5, 'seconds').toISOString()
      endTime = moment(alert.createdOn).clone().add(5, 'seconds').toISOString()

      let payloadInput
      payloadInput = {
        imei,
        rawAlertCode: alert.alertCode,
        rawAlertCreatedOn: alert.createdOn,
        startTime,
        endTime,
        isEvent: true,
        useInMemoryDB: true,
      }

      const isDmsAdas = this.hasMedia(alert)

      if (isDmsAdas) {
        payloadInput.alertCategory = alertType.toUpperCase()
      }

      const isBsd = this.isBsdAlert(alert)

      if (isBsd) {
        payloadInput.alertCategory = alertType.toUpperCase()
      }

      const isCaptureEvent = this.hasCaptureEventMedia(alert)

      if (isCaptureEvent) {
        payloadInput.channel = 1
      }
      this.setPollingStatus(alert, 'loading')

      const response = await this.$apollo.mutate({
        mutation: SET_UPLOAD_MEDIA,
        variables: {
          input: payloadInput,
        },
      })
      const responseMessage = response.data.setUploadMedia.setUploadMedia.message
      const dataDvh = response?.data?.setUploadMedia?.setUploadMedia?.data || []

      if (responseMessage === 'Sent') {
        dataDvh.forEach((item) => {
          this.$store.commit('notification/addDataDvhRequested', {
            ...item,
            rawAlertId: alert.rawAlertId || alert.id,
          })
        })
        await this.getDetailedVideo(alert)
      } else if (responseMessage === 'Not Sent(No video downloaded)') {
        return this.setPollingStatus(alert, 'failed')
      }
    },

    hasMedia(alert) {
      return isDmsAdas(alert)
    },

    canShowAlertMediaPanel(alert) {
      return canShowAlertMediaPanel(alert, { getDeviceType: this.getDeviceType })
    },

    hasCaptureEventMedia(alert) {
      return hasCaptureEventMedia(alert, { getDeviceType: this.getDeviceType })
    },
    isBsdAlert(alert) {
      return isBsdAlert(alert)
    },

    mediaStatus(
      alert,
      { pollingStatus, canCheck, canRequest, retryCount, videoData, isOfflineDevice }
    ) {
      const popup = this.popupLists.find((popup) => popup.alert.id === alert.id)
      if (popup) {
        this.$set(popup.alert, 'canCheck', canCheck)
        this.$set(popup.alert, 'canRequest', canRequest)
        this.$set(popup.alert, 'pollingStatus', pollingStatus)
        if (videoData !== undefined) this.$set(popup.alert, 'videoData', videoData)
        this.$set(popup.alert, 'retryCount', retryCount)
        this.$set(popup.alert, 'isOfflineDevice', isOfflineDevice)
      }
      this.$store.dispatch('notification/setMediaPollingState', {
        id: alert.id,
        pollingStatus,
        canCheck,
        canRequest,
        retryCount,
        videoData,
        isOfflineDevice,
      })
    },

    setPollingStatus(alert, pollingStatus, overrides = {}) {
      const statePatch = {
        canCheck: false,
        canRequest: false,
        retryCount: 0,
        isOfflineDevice: false,
        ...overrides,
      }

      this.$set(alert, 'pollingStatus', pollingStatus)
      this.$set(alert, 'canCheck', statePatch.canCheck)
      this.$set(alert, 'canRequest', statePatch.canRequest)
      this.$set(alert, 'retryCount', statePatch.retryCount)
      this.$set(alert, 'isOfflineDevice', statePatch.isOfflineDevice)
      if (Object.prototype.hasOwnProperty.call(statePatch, 'videoData')) {
        this.$set(alert, 'videoData', statePatch.videoData)
      }
      this.mediaStatus(alert, { pollingStatus, ...statePatch })
    },

    async getLastReceive(vehicleIds) {
      const response = await this.$apollo.query({
        query: GET_VEHICLE_STATUSES_LAST_RECEIVE,
        fetchPolicy: 'no-cache',
        variables: {
          filter: {
            vehicleId: vehicleIds,
            vehicleStatus: ['service', 'archived', 'repair'],
          },
        },
      })

      const checkData = this.vehicleStatusesLastReceive.find((item) => {
        item.vehicleId == response.data.vehicleStatuses.vehicleStatuses[0].vehicleId
      })
      if (!checkData) {
        this.vehicleStatusesLastReceive.push(response.data.vehicleStatuses.vehicleStatuses[0])
      }
    },

    async getVehicleStatusByVehicleId(vehicleId) {
      const response = await this.$apollo.query({
        fetchPolicy: 'no-cache',
        query: GET_VEHICLE_STATUSES_TRACKVISION,
        variables: {
          filter: {
            vehicleId,
            vehicleStatus: ['service', 'archived', 'repair'],
          },
        },
      })
      if (response.data.vehicleStatuses.isSuccessful) {
        return response.data.vehicleStatuses.vehicleStatuses[0]
      }
    },

    async openVideo(item) {
      try {
        this.setSelectedAlert(item)
        this.videoUrl = item.videoData.url
        await this.$nextTick()
        this.$bvModal.show('modal-video-alert')
      } catch (error) {
        console.error('openVideo error:', error)
      }
    },
    async openNewModal(item, type = null) {
      try {
        const alertId = item.rawAlertId

        if (type == 'request-media') {
          const canOpenModal = await this.startReqMedia(item)
          if (!canOpenModal) return
        }

        if (type == 'check-media') {
          await this.pollForVideo(item)
        }

        const alertDetail = await this.refreshSelectedAlert(alertId)
        if (!alertDetail) return
        const dvhData = alertDetail.media || []

        this.$store.commit('notification/setDetailNotification', alertDetail)
        this.$store.commit('notification/setListNotificationMedia', dvhData)
        await this.$nextTick()
        this.$bvModal.show('modal-alert-media')
      } catch (error) {
        console.error('openNewModal error:', error)
      }
    },
    async openVideoModalEvidence(item) {
      try {
        this.setSelectedAlert(item)
        await this.getDataMultiEvidence(item)

        await this.$nextTick()
        this.$bvModal.show('modal-video-alert')
      } catch (error) {
        console.error('openVideoModalEvidence error:', error)
      }
    },

    setSelectedAlert(alertDetail) {
      this.selectedAlert = alertDetail || null
    },

    async refreshSelectedAlert(alertId) {
      const response = await this.getAlertDetail(alertId)
      const alertDetail = response?.data?.rawAlert?.rawAlert

      if (!alertDetail) {
        this.setSelectedAlert(null)
        return null
      }

      this.setSelectedAlert(alertDetail)
      return alertDetail
    },

    async getDataMultiEvidence(alert) {
      let vehicleIdCam = alert.vehicleId
      if (alert?.childVehicleId) {
        vehicleIdCam = alert?.childVehicleId
      }

      const [resStatusText, resFdh] = await Promise.all([
        this.getStatusTextFromVehicle(vehicleIdCam),
        this.getDownloadVideoHistoriesByEvent(vehicleIdCam, alert.createdOn),
      ])

      const dataTv = resStatusText.data.vehicleVideoTrackers.vehicleVideoTrackers[0]

      this.statusTextSelected = dataTv.statusText
      this.deviceCodeSelected = dataTv.vehicle.device.deviceCode
      this.vehicleIdCamSelected = dataTv.vehicleId
      this.imeiCamSelected = dataTv.vehicle.imei
      this.rawAlertId = alert.rawAlertId

      const dataVideo =
        resFdh.data.findDownloadVideoHistories.findDownloadVideoHistories.data.filter(
          (data) => data.identifier === 'V' || data.identifier === 'R'
        ) ?? []

      this.dataDvh = dataVideo
    },

    updateDataDvh(downloadId, dataDvh) {
      this.dataDvh = this.dataDvh.map((d) => {
        if (d.downloadId === downloadId) {
          return dataDvh
        }
        return d
      })
    },

    async getStatusTextFromVehicle(vehicleId) {
      const response = await this.$apollo.query({
        query: GET_VEHICLE_STATUS_TEXT,
        fetchPolicy: 'no-cache',
        variables: {
          filter: {
            vehicleId: [vehicleId],
          },
        },
      })
      return response
    },

    async getAlertDetail(alertId) {
      const response = await this.$apollo.query({
        query: GET_RAW_ALERT,
        fetchPolicy: 'no-cache',
        variables: {
          filter: {
            rawAlertId: alertId,
          },
        },
      })

      return response
    },

    setAlertList(alert) {
      const id = alert.alertRuleIds?.[0]
      const {
        autoPopupAlertRules = {},
        urgentAlertRules = {},
        importantAlertRules = {},
      } = this.alertRulesObj

      const alertRule =
        id && (autoPopupAlertRules[id] || urgentAlertRules[id] || importantAlertRules[id])

      const isUrgent = this.isAlertUrgent(alert)
      const isImportant = this.isAlertImportant(alert)

      const formattedAlert = {
        ...alert,
        alert: {
          descriptionIdn: alert.alertDescription.idn,
          descriptionEng: alert.alertDescription.eng,
          iconUrl: alert.iconUrl ?? '',
        },
        driver: {
          fullname: alert.driverName,
        },
        vehicle: {
          id: alert.vehicleId,
          licensePlate: alert.licensePlate,
        },
        isUrgent,
        isImportant,
        isResolved: false,
        isRead: false,
        sourceDeviceCategory: alert.sourceDeviceCategory ?? '',
        alertRule,
      }

      if (this.isAlertUrgent(formattedAlert) || this.isAlertImportant(formattedAlert)) {
        this.alertWS = formattedAlert
        const sideBar = localStorage.getItem('notifSideBarOpen')
        const isUrgentAlert = this.isAlertUrgent(formattedAlert)

        if (!sideBar && !this.alertCenterVisible) {
          this.top3alert.unshift(formattedAlert)
          if (isUrgentAlert) {
            const audio = new Audio(urgentSoundNotification)
            audio.play()
          } else {
            const audio = new Audio(soundNotification)
            audio.play()
          }
          if (this.top3alert.length > 3) {
            this.top3alert = this.top3alert.slice(0, 3)
          }
        } else {
          this.top3alert = []
          if (isUrgentAlert) {
            const audio = new Audio(urgentSoundNotification)
            audio.play()
          }
        }

        if (this.isAlertUrgent(formattedAlert)) {
          formattedAlert.id = alert.rawAlertId
        }
      }
    },
    resolveAlertByWs(payload) {
      const decoded = msgpack.decode(payload.data)
      let mode
      if (decoded.m === 'a') {
        mode = 'All'
      } else if (decoded.m === 's') {
        mode = 'Selection'
      } else {
        mode = 'Exclude'
      }
      const data = {
        mode: mode,
        startDate: new Date(decoded.st),
        endDate: new Date(decoded.et),
        isResolved: decoded.r === 1,
        userId: decoded.u,
        userName: decoded.un,
        vehicles: new Map(decoded.v),
        rawAlertId: decoded.id?.map((id) => Number(id)),
      }

      if (data.mode === 'Selection' && Array.isArray(data.rawAlertId)) {
        data.rawAlertId.forEach((id) => {
          this.$store.dispatch('notification/updateAlertListResolved', {
            id: id,
            isResolved: data.isResolved,
          })
        })
      }

      const alertCenterRef = this.$refs.alertCenter
      this.refreshVisibleUnresolvedAccordion(alertCenterRef)
      this.refreshAlertCenterCounts()
    },
    handleAlertFeedbackByWs() {
      this.refreshVisibleUnresolvedAccordion()
      this.refreshAlertCenterCounts()
    },
    refreshVisibleUnresolvedAccordion(alertCenterRef = this.$refs.alertCenter) {
      if (!alertCenterRef || !alertCenterRef.showUnresolvedOnly) {
        return
      }

      if (alertCenterRef.openAccordion === 'urgent') {
        alertCenterRef.loadedUnresolvedAccordions.urgent = false
        alertCenterRef.showWsIndicator.urgent = false
        alertCenterRef.loadUnresolvedUrgentData()
      } else if (alertCenterRef.openAccordion === 'important') {
        alertCenterRef.loadedUnresolvedAccordions.important = false
        alertCenterRef.showWsIndicator.important = false
        alertCenterRef.loadUnresolvedImportantData()
      }
    },
    refreshAlertCenterCounts: debounce(function () {
      const alertCenterRef = this.$refs.alertCenter
      if (!alertCenterRef) {
        return
      }

      alertCenterRef.checkTotalImportantAlerts().catch((error) => {
        // eslint-disable-next-line no-console
        console.error('Failed to refresh alert center counts', error)
      })
    }, 300),
    openMap(alert) {
      window.open(
        `http://maps.google.com/maps?&z=15&mrt=yp&t=m&q=${alert.latitude}+${alert.longitude}`,
        '_blank'
      )
    },
    recenterMap(alert, index) {
      this.$nextTick(() => {
        const map = this.$refs.detailAlertMap[index]?.$mapObject
        if (!map) {
          return
        }

        const lat = parseFloat(alert.latitude)
        const lng = parseFloat(alert.longitude)

        const center = { lat, lng }
        map.setCenter(center)
      })
    },

    openLiveview(alert) {
      this.track('Click Lacak Kendaraan on Notification Preview', {
        'license-plate': alert.licensePlate,
        'notification-name':
          this.language == 'en' ? alert.alert.descriptionEng : alert.alert.descriptionIdn,
      })

      const url = `${window.location.protocol}//${window.location.host}/liveview-2/?type=vehicle&vehicleId=${alert.vehicleId}`
      window.location.href = url
    },
    openDetailAlert(item) {
      const createdOn = new Date(item.createdOn).getTime()
      const id = item.rawAlertId
        ? `${item.rawAlertId}`
        : `${item.alertCode}-${item.vehicleId}-${createdOn}-${item.alertFlag}`
      this.$router
        .push({
          name: 'Notification Detail',
          params: { id },
        })
        .then(() => {
          this.$root.$emit('notification-detail-reload')
        })
    },

    async markAsResolved(popup, status, actionType) {
      this.$store.dispatch('notification/updatePopupResolving', {
        id: popup.id,
        isResolving: true,
      })

      try {
        const isSuccess = await saveAlertResolveAction(this.getPopupActionContext(popup), {
          status,
          actionType,
          trackEvent: 'Resolve Notification from Notification Preview',
        })

        if (isSuccess) {
          this.refreshVisibleUnresolvedAccordion()
          this.refreshAlertCenterCounts()
        }

        return isSuccess
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error marking as resolved:', error)
        this.$mcToast.error(this.$t('global.alert.text.error'))
      } finally {
        this.$store.dispatch('notification/updatePopupResolving', {
          id: popup.id,
          isResolving: false,
        })
      }
    },

    clickCall(alert) {
      if (
        this.hasAccessAll([
          'b3f-two-way-communication:read',
          'b3f-two-way-communication-all-module:read',
        ])
      ) {
        this.track('Alert Center - VoIP Admin make a call', {
          entryPoint: 'Alert Center',
          alertCode: alert.alertCode,
          alertDescription: alert.alert.descriptionIdn,
        })
        this.$store.dispatch('voip/startNewCall', {
          dataNewCall: {
            vehicleId: alert.callState.vehicleIdVoip,
            licensePlate: alert.vehicle?.licensePlate,
            driver: alert.driver?.fullname ?? null,
            imei: alert.callState.imeiVoip,
            deviceType: alert.callState.deviceType,
            entryPoint: 'alertCenter',
          },
        })
      }
    },

    clickEndCall(alert) {
      this.track('Alert Center - VoIP End Call', {
        entryPoint: 'Alert Center',
      })
      this.$store.dispatch('voip/endCall', {
        vehicleId: alert.callState.vehicleIdVoip,
      })
    },
    getNotificationUrl(item) {
      const createdOn = new Date(item.createdOn).getTime()
      const id = item.rawAlertId
        ? `${item.rawAlertId}`
        : `${item.alertCode}-${item.vehicleId}-${createdOn}-${item.alertFlag}`
      const route = this.$router.resolve({
        name: 'Notification Detail',
        params: { id: id },
      })
      return route.href
    },
    showOnboarding() {
      this.track('Click Notification Onboarding Icon (Web)')
      this.onboardingVisible = true
    },
    toggleNotification(type) {
      if (this.activeNotification === type) {
        this.activeNotification = null
      } else {
        this.activeNotification = type
      }
    },
    getActionIcons(alert) {
      const deviceCode = getDeviceCode(alert)
      return getAlertActionIcons({
        alert,
        deviceCode,
        hasAccessAll: (scopes) => this.hasAccessAll(scopes),
        track: (event, data) => this.track(event, data),
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import './navbar.scss';
</style>
